(() => {
  !(function () {
    "use strict";
    var e =
        "function" == typeof Promise
          ? Promise
          : function (e) {
              var n,
                r = [],
                i = 0;
              return (
                e(function (e) {
                  (n = e), (i = 1), r.splice(0).forEach(o);
                }),
                { then: o }
              );
              function o(e) {
                return i ? setTimeout(e, 0, n) : r.push(e), this;
              }
            },
      n = function (e, n) {
        var r = function (e) {
            for (var n = 0, r = e.length; n < r; n++) i(e[n]);
          },
          i = function (e) {
            var n = e.target,
              r = e.attributeName,
              i = e.oldValue;
            n.attributeChangedCallback(r, i, n.getAttribute(r));
          };
        return function (o, a) {
          var s = o.constructor.observedAttributes;
          return (
            s &&
              e(a).then(function () {
                new n(r).observe(o, {
                  attributes: !0,
                  attributeOldValue: !0,
                  attributeFilter: s,
                });
                for (var e = 0, a = s.length; e < a; e++)
                  o.hasAttribute(s[e]) &&
                    i({ target: o, attributeName: s[e], oldValue: null });
              }),
            o
          );
        };
      },
      r = "querySelectorAll";
    function i(e) {
      this.observe(e, { subtree: !0, childList: !0 });
    }
    var o = "querySelectorAll",
      a = self,
      s = a.document,
      l = a.Element,
      u = a.MutationObserver,
      c = a.Set,
      f = a.WeakMap,
      $ = function (e) {
        return o in e;
      },
      d = [].filter,
      h = function (e) {
        var n,
          a,
          h,
          p,
          m,
          g = new f(),
          _ = function (n, r) {
            var i;
            if (r)
              for (
                var o,
                  a,
                  s =
                    (o = n).matches ||
                    o.webkitMatchesSelector ||
                    o.msMatchesSelector,
                  l = 0,
                  u = b.length;
                l < u;
                l++
              )
                s.call(n, (a = b[l])) &&
                  (g.has(n) || g.set(n, new c()),
                  (i = g.get(n)).has(a) || (i.add(a), e.handle(n, r, a)));
            else
              g.has(n) &&
                ((i = g.get(n)),
                g.delete(n),
                i.forEach(function (i) {
                  e.handle(n, r, i);
                }));
          },
          v = function (e) {
            for (
              var n =
                  !(arguments.length > 1 && void 0 !== arguments[1]) ||
                  arguments[1],
                r = 0,
                i = e.length;
              r < i;
              r++
            )
              _(e[r], n);
          },
          b = e.query,
          y = e.root || s,
          T =
            ((n = _),
            (a = y),
            (h = u),
            (p = function e(i, o, a, s, l) {
              for (var u = 0, c = i.length; u < c; u++) {
                var f = i[u];
                (l || r in f) &&
                  (s
                    ? o.has(f) || (o.add(f), a.delete(f), n(f, s))
                    : a.has(f) || (a.add(f), o.delete(f), n(f, s)),
                  l || e(f[r]("*"), o, a, s, !0));
              }
            }),
            ((m = new (h || MutationObserver)(function (e) {
              for (
                var n = new Set(), r = new Set(), i = 0, o = e.length;
                i < o;
                i++
              ) {
                var a = e[i],
                  s = a.addedNodes;
                p(a.removedNodes, n, r, !1, !1), p(s, n, r, !0, !1);
              }
            })).add = i),
            m.add(a || document),
            m),
          w = l.prototype.attachShadow;
        return (
          w &&
            (l.prototype.attachShadow = function (e) {
              var n = w.call(this, e);
              return T.add(n), n;
            }),
          b.length && v(y[o](b)),
          {
            drop: function (e) {
              for (var n = 0, r = e.length; n < r; n++) g.delete(e[n]);
            },
            flush: function () {
              for (var e = T.takeRecords(), n = 0, r = e.length; n < r; n++)
                v(d.call(e[n].removedNodes, $), !1),
                  v(d.call(e[n].addedNodes, $), !0);
            },
            observer: T,
            parse: v,
          }
        );
      },
      p = self,
      m = p.document,
      g = p.Map,
      _ = p.MutationObserver,
      v = p.Object,
      b = p.Set,
      y = p.WeakMap,
      T = p.Element,
      w = p.HTMLElement,
      x = p.Node,
      E = p.Error,
      k = p.TypeError,
      P = p.Reflect,
      S = self.Promise || e,
      R = v.defineProperty,
      A = v.keys,
      L = v.getOwnPropertyNames,
      N = v.setPrototypeOf,
      D = !self.customElements,
      O = function (e) {
        for (var n = A(e), r = [], i = n.length, o = 0; o < i; o++)
          (r[o] = e[n[o]]), delete e[n[o]];
        return function () {
          for (var o = 0; o < i; o++) e[n[o]] = r[o];
        };
      };
    if (D) {
      var C = function () {
          var e = this.constructor;
          if (!H.has(e)) throw new k("Illegal constructor");
          var n = H.get(e);
          if (z) return U(z, n);
          var r = I.call(m, n);
          return U(N(r, e.prototype), n);
        },
        I = m.createElement,
        H = new g(),
        W = new g(),
        M = new g(),
        F = new g(),
        B = [],
        q = h({
          query: B,
          handle: function (e, n, r) {
            var i = M.get(r);
            if (n && !i.isPrototypeOf(e)) {
              var o = O(e);
              z = N(e, i);
              try {
                new i.constructor();
              } finally {
                (z = null), o();
              }
            }
            var a = "".concat(n ? "" : "dis", "connectedCallback");
            a in i && e[a]();
          },
        }).parse,
        z = null,
        V = function (n) {
          if (!W.has(n)) {
            var r,
              i = new e(function (e) {
                r = e;
              });
            W.set(n, { $: i, _: r });
          }
          return W.get(n).$;
        },
        U = n(V, _);
      R(self, "customElements", {
        configurable: !0,
        value: {
          define: function (e, n) {
            if (F.has(e))
              throw new E(
                'the name "'.concat(
                  e,
                  '" has already been used with this registry'
                )
              );
            H.set(n, e),
              M.set(e, n.prototype),
              F.set(e, n),
              B.push(e),
              V(e).then(function () {
                q(m.querySelectorAll(e));
              }),
              W.get(e)._(n);
          },
          get: function (e) {
            return F.get(e);
          },
          whenDefined: V,
        },
      }),
        R((C.prototype = w.prototype), "constructor", { value: C }),
        R(self, "HTMLElement", { configurable: !0, value: C }),
        R(m, "createElement", {
          configurable: !0,
          value: function (e, n) {
            var r = n && n.is,
              i = r ? F.get(r) : F.get(e);
            return i ? new i() : I.call(m, e);
          },
        }),
        "isConnected" in x.prototype ||
          R(x.prototype, "isConnected", {
            configurable: !0,
            get: function () {
              return !(
                this.ownerDocument.compareDocumentPosition(this) &
                this.DOCUMENT_POSITION_DISCONNECTED
              );
            },
          });
    } else
      try {
        var j = function e() {
          return self.Reflect.construct(HTMLLIElement, [], e);
        };
        j.prototype = HTMLLIElement.prototype;
        var K = "extends-li";
        self.customElements.define("extends-li", j, { extends: "li" }),
          (D = 0 > m.createElement("li", { is: K }).outerHTML.indexOf(K));
        var X = self.customElements,
          Y = X.get,
          G = X.whenDefined;
        R(self.customElements, "whenDefined", {
          configurable: !0,
          value: function (e) {
            var n = this;
            return G.call(this, e).then(function (r) {
              return r || Y.call(n, e);
            });
          },
        });
      } catch (J) {
        D = !D;
      }
    if (D) {
      var Q = function (e) {
          eh(eo.get(e).querySelectorAll(this), e.isConnected);
        },
        Z = self.customElements,
        ee = T.prototype.attachShadow,
        et = m.createElement,
        en = Z.define,
        er = Z.get,
        ei = (
          P || {
            construct: function (e) {
              return e.call(this);
            },
          }
        ).construct,
        eo = new y(),
        ea = new b(),
        es = new g(),
        el = new g(),
        eu = new g(),
        ec = new g(),
        ef = [],
        e$ = [],
        ed = function (e) {
          return ec.get(e) || er.call(Z, e);
        },
        eh = h({
          query: e$,
          handle: function (e, n, r) {
            var i = eu.get(r);
            if (n && !i.isPrototypeOf(e)) {
              var o = O(e);
              e_ = N(e, i);
              try {
                new i.constructor();
              } finally {
                (e_ = null), o();
              }
            }
            var a = "".concat(n ? "" : "dis", "connectedCallback");
            a in i && e[a]();
          },
        }).parse,
        ep = h({
          query: ef,
          handle: function (e, n) {
            eo.has(e) &&
              (n ? ea.add(e) : ea.delete(e), e$.length && Q.call(e$, e));
          },
        }).parse,
        em = function (e) {
          if (!el.has(e)) {
            var n,
              r = new S(function (e) {
                n = e;
              });
            el.set(e, { $: r, _: n });
          }
          return el.get(e).$;
        },
        eg = n(em, _),
        e_ = null;
      L(self)
        .filter(function (e) {
          return /^HTML/.test(e);
        })
        .forEach(function (e) {
          var n = self[e];
          function r() {
            var e = this.constructor;
            if (!es.has(e)) throw new k("Illegal constructor");
            var r = es.get(e),
              i = r.is,
              o = r.tag;
            if (i) {
              if (e_) return eg(e_, i);
              var a = et.call(m, o);
              return a.setAttribute("is", i), eg(N(a, e.prototype), i);
            }
            return ei.call(this, n, [], e);
          }
          R((r.prototype = n.prototype), "constructor", { value: r }),
            R(self, e, { value: r });
        }),
        R(m, "createElement", {
          configurable: !0,
          value: function (e, n) {
            var r = n && n.is;
            if (r) {
              var i = ec.get(r);
              if (i && es.get(i).tag === e) return new i();
            }
            var o = et.call(m, e);
            return r && o.setAttribute("is", r), o;
          },
        }),
        ee &&
          (T.prototype.attachShadow = function (e) {
            var n = ee.call(this, e);
            return eo.set(this, n), n;
          }),
        R(Z, "get", { configurable: !0, value: ed }),
        R(Z, "whenDefined", { configurable: !0, value: em }),
        R(Z, "define", {
          configurable: !0,
          value: function (e, n, r) {
            if (ed(e))
              throw new E(
                "'".concat(e, "' has already been defined as a custom element")
              );
            var i,
              o = r && r.extends;
            es.set(n, o ? { is: e, tag: o } : { is: "", tag: e }),
              o
                ? ((i = "".concat(o, '[is="').concat(e, '"]')),
                  eu.set(i, n.prototype),
                  ec.set(e, n),
                  e$.push(i))
                : (en.apply(Z, arguments), ef.push((i = e))),
              em(e).then(function () {
                o
                  ? (eh(m.querySelectorAll(i)), ea.forEach(Q, [i]))
                  : ep(m.querySelectorAll(i));
              }),
              el.get(e)._(n);
          },
        });
    }
  })(),
    (i = {}),
    (function (e, n) {
      function r() {
        (this._delay = 0),
          (this._endDelay = 0),
          (this._fill = "none"),
          (this._iterationStart = 0),
          (this._iterations = 1),
          (this._duration = 0),
          (this._playbackRate = 1),
          (this._direction = "normal"),
          (this._easing = "linear"),
          (this._easingFunction = d);
      }
      function i() {
        return e.isDeprecated(
          "Invalid timing inputs",
          "2016-03-02",
          "TypeError exceptions will be thrown instead.",
          !0
        );
      }
      function o(n, i, o) {
        var a = new r();
        return (
          i && ((a.fill = "both"), (a.duration = "auto")),
          "number" != typeof n || isNaN(n)
            ? void 0 !== n &&
              Object.getOwnPropertyNames(n).forEach(function (r) {
                "auto" != n[r] &&
                  !(
                    ("number" == typeof a[r] || "duration" == r) &&
                    ("number" != typeof n[r] || isNaN(n[r]))
                  ) &&
                  ("fill" != r || -1 != f.indexOf(n[r])) &&
                  ("direction" != r || -1 != $.indexOf(n[r])) &&
                  (("playbackRate" == r &&
                    1 !== n[r] &&
                    e.isDeprecated(
                      "AnimationEffectTiming.playbackRate",
                      "2014-11-28",
                      "Use Animation.playbackRate instead."
                    )) ||
                    (a[r] = n[r]));
              })
            : (a.duration = n),
          a
        );
      }
      function a(e, n, r, i) {
        return e < 0 || e > 1 || r < 0 || r > 1
          ? d
          : function (o) {
              function a(e, n, r) {
                return (
                  3 * e * (1 - r) * (1 - r) * r +
                  3 * n * (1 - r) * r * r +
                  r * r * r
                );
              }
              if (o <= 0) {
                var s = 0;
                return e > 0 ? (s = n / e) : !n && r > 0 && (s = i / r), s * o;
              }
              if (o >= 1) {
                var l = 0;
                return (
                  r < 1
                    ? (l = (i - 1) / (r - 1))
                    : 1 == r && e < 1 && (l = (n - 1) / (e - 1)),
                  1 + l * (o - 1)
                );
              }
              for (var u = 0, c = 1; u < c; ) {
                var f = (u + c) / 2,
                  $ = a(e, r, f);
                if (1e-5 > Math.abs(o - $)) break;
                $ < o ? (u = f) : (c = f);
              }
              return a(n, i, f);
            };
      }
      function s(e, n) {
        return function (r) {
          if (r >= 1) return 1;
          var i = 1 / e;
          return (r += n * i) - (r % i);
        };
      }
      function l(e) {
        _ || (_ = document.createElement("div").style),
          (_.animationTimingFunction = ""),
          (_.animationTimingFunction = e);
        var n = _.animationTimingFunction;
        if ("" == n && i())
          throw TypeError(e + " is not a valid value for easing");
        return n;
      }
      function u(e) {
        if ("linear" == e) return d;
        var n = b.exec(e);
        if (n) return a.apply(this, n.slice(1).map(Number));
        var r = y.exec(e);
        if (r) return s(Number(r[1]), m);
        var i = T.exec(e);
        return i
          ? s(Number(i[1]), { start: h, middle: p, end: m }[i[2]])
          : g[e] || d;
      }
      function c(e, n, r) {
        if (null == n) return w;
        var i = r.delay + e + r.endDelay;
        return n < Math.min(r.delay, i)
          ? x
          : n >= Math.min(r.delay + e, i)
          ? E
          : k;
      }
      var f = "backwards|forwards|both|none".split("|"),
        $ = "reverse|alternate|alternate-reverse".split("|"),
        d = function (e) {
          return e;
        };
      r.prototype = {
        _setMember: function (n, r) {
          (this["_" + n] = r),
            this._effect &&
              ((this._effect._timingInput[n] = r),
              (this._effect._timing = e.normalizeTimingInput(
                this._effect._timingInput
              )),
              (this._effect.activeDuration = e.calculateActiveDuration(
                this._effect._timing
              )),
              this._effect._animation &&
                this._effect._animation._rebuildUnderlyingAnimation());
        },
        get playbackRate() {
          return this._playbackRate;
        },
        set delay(t) {
          this._setMember("delay", t);
        },
        get delay() {
          return this._delay;
        },
        set endDelay(t) {
          this._setMember("endDelay", t);
        },
        get endDelay() {
          return this._endDelay;
        },
        set fill(t) {
          this._setMember("fill", t);
        },
        get fill() {
          return this._fill;
        },
        set iterationStart(t) {
          if ((isNaN(t) || t < 0) && i())
            throw TypeError(
              "iterationStart must be a non-negative number, received: " + t
            );
          this._setMember("iterationStart", t);
        },
        get iterationStart() {
          return this._iterationStart;
        },
        set duration(t) {
          if ("auto" != t && (isNaN(t) || t < 0) && i())
            throw TypeError(
              "duration must be non-negative or auto, received: " + t
            );
          this._setMember("duration", t);
        },
        get duration() {
          return this._duration;
        },
        set direction(t) {
          this._setMember("direction", t);
        },
        get direction() {
          return this._direction;
        },
        set easing(t) {
          (this._easingFunction = u(l(t))), this._setMember("easing", t);
        },
        get easing() {
          return this._easing;
        },
        set iterations(t) {
          if ((isNaN(t) || t < 0) && i())
            throw TypeError("iterations must be non-negative, received: " + t);
          this._setMember("iterations", t);
        },
        get iterations() {
          return this._iterations;
        },
      };
      var h = 1,
        p = 0.5,
        m = 0,
        g = {
          ease: a(0.25, 0.1, 0.25, 1),
          "ease-in": a(0.42, 0, 1, 1),
          "ease-out": a(0, 0, 0.58, 1),
          "ease-in-out": a(0.42, 0, 0.58, 1),
          "step-start": s(1, h),
          "step-middle": s(1, p),
          "step-end": s(1, m),
        },
        _ = null,
        v = "\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*",
        b = RegExp("cubic-bezier\\(" + v + "," + v + "," + v + "," + v + "\\)"),
        y = /steps\(\s*(\d+)\s*\)/,
        T = /steps\(\s*(\d+)\s*,\s*(start|middle|end)\s*\)/,
        w = 0,
        x = 1,
        E = 2,
        k = 3;
      (e.cloneTimingInput = function (e) {
        if ("number" == typeof e) return e;
        var n = {};
        for (var r in e) n[r] = e[r];
        return n;
      }),
        (e.makeTiming = o),
        (e.numericTimingToObject = function (e) {
          return (
            "number" == typeof e &&
              (e = isNaN(e) ? { duration: 0 } : { duration: e }),
            e
          );
        }),
        (e.normalizeTimingInput = function (n, r) {
          return o((n = e.numericTimingToObject(n)), r);
        }),
        (e.calculateActiveDuration = function (e) {
          var n;
          return Math.abs(
            (0 === (n = e).duration || 0 === n.iterations
              ? 0
              : n.duration * n.iterations) / e.playbackRate
          );
        }),
        (e.calculateIterationProgress = function (e, n, r) {
          var i = c(e, n, r),
            o = (function (e, n, r, i, o) {
              switch (i) {
                case x:
                  return "backwards" == n || "both" == n ? 0 : null;
                case k:
                  return r - o;
                case E:
                  return "forwards" == n || "both" == n ? e : null;
                case w:
                  return null;
              }
            })(e, r.fill, n, i, r.delay);
          if (null === o) return null;
          var a,
            s,
            l,
            u,
            f,
            $,
            d,
            h,
            p,
            m,
            g,
            _,
            v,
            b,
            y,
            T,
            P,
            S =
              ((a = r.duration),
              (s = i),
              (l = r.iterations),
              (u = o),
              ($ = f = r.iterationStart),
              0 === a ? s !== x && ($ += l) : ($ += u / a),
              $),
            R =
              ((d = S),
              (h = r.iterationStart),
              (p = i),
              (m = r.iterations),
              (g = o),
              (_ = r.duration),
              0 != (v = d === 1 / 0 ? h % 1 : d % 1) ||
                p !== E ||
                0 === m ||
                (0 === g && 0 !== _) ||
                (v = 1),
              v),
            A =
              ((b = i),
              (y = r.iterations),
              (T = R),
              (P = S),
              b === E && y === 1 / 0
                ? 1 / 0
                : 1 === T
                ? Math.floor(P) - 1
                : Math.floor(P)),
            L = (function (e, n, r) {
              var i = e;
              if ("normal" !== e && "reverse" !== e) {
                var o = n;
                "alternate-reverse" === e && (o += 1),
                  (i = "normal"),
                  o !== 1 / 0 && o % 2 != 0 && (i = "reverse");
              }
              return "normal" === i ? r : 1 - r;
            })(r.direction, A, R);
          return r._easingFunction(L);
        }),
        (e.calculatePhase = c),
        (e.normalizeEasing = l),
        (e.parseEasingFunction = u);
    })((r = {})),
    (function (e, n) {
      function r(e, n) {
        return (e in u && u[e][n]) || n;
      }
      function i(e, n, i) {
        var o;
        if (
          "display" !== (o = e) &&
          0 !== o.lastIndexOf("animation", 0) &&
          0 !== o.lastIndexOf("transition", 0)
        ) {
          var l = a[e];
          if (l)
            for (var u in ((s.style[e] = n), l)) {
              var c = l[u],
                f = s.style[c];
              i[c] = r(c, f);
            }
          else i[e] = r(e, n);
        }
      }
      function o(e) {
        var n = [];
        for (var r in e)
          if (!(r in ["easing", "offset", "composite"])) {
            var i = e[r];
            Array.isArray(i) || (i = [i]);
            for (var o, a = i.length, s = 0; s < a; s++)
              ((o = {}).offset =
                "offset" in e ? e.offset : 1 == a ? 1 : s / (a - 1)),
                "easing" in e && (o.easing = e.easing),
                "composite" in e && (o.composite = e.composite),
                (o[r] = i[s]),
                n.push(o);
          }
        return (
          n.sort(function (e, n) {
            return e.offset - n.offset;
          }),
          n
        );
      }
      var a = {
          background: [
            "backgroundImage",
            "backgroundPosition",
            "backgroundSize",
            "backgroundRepeat",
            "backgroundAttachment",
            "backgroundOrigin",
            "backgroundClip",
            "backgroundColor",
          ],
          border: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
          ],
          borderBottom: [
            "borderBottomWidth",
            "borderBottomStyle",
            "borderBottomColor",
          ],
          borderColor: [
            "borderTopColor",
            "borderRightColor",
            "borderBottomColor",
            "borderLeftColor",
          ],
          borderLeft: ["borderLeftWidth", "borderLeftStyle", "borderLeftColor"],
          borderRadius: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomRightRadius",
            "borderBottomLeftRadius",
          ],
          borderRight: [
            "borderRightWidth",
            "borderRightStyle",
            "borderRightColor",
          ],
          borderTop: ["borderTopWidth", "borderTopStyle", "borderTopColor"],
          borderWidth: [
            "borderTopWidth",
            "borderRightWidth",
            "borderBottomWidth",
            "borderLeftWidth",
          ],
          flex: ["flexGrow", "flexShrink", "flexBasis"],
          font: [
            "fontFamily",
            "fontSize",
            "fontStyle",
            "fontVariant",
            "fontWeight",
            "lineHeight",
          ],
          margin: ["marginTop", "marginRight", "marginBottom", "marginLeft"],
          outline: ["outlineColor", "outlineStyle", "outlineWidth"],
          padding: [
            "paddingTop",
            "paddingRight",
            "paddingBottom",
            "paddingLeft",
          ],
        },
        s = document.createElementNS("http://www.w3.org/1999/xhtml", "div"),
        l = { thin: "1px", medium: "3px", thick: "5px" },
        u = {
          borderBottomWidth: l,
          borderLeftWidth: l,
          borderRightWidth: l,
          borderTopWidth: l,
          fontSize: {
            "xx-small": "60%",
            "x-small": "75%",
            small: "89%",
            medium: "100%",
            large: "120%",
            "x-large": "150%",
            "xx-large": "200%",
          },
          fontWeight: { normal: "400", bold: "700" },
          outlineWidth: l,
          textShadow: { none: "0px 0px 0px transparent" },
          boxShadow: { none: "0px 0px 0px 0px transparent" },
        };
      (e.convertToArrayForm = o),
        (e.normalizeKeyframes = function (n) {
          if (null == n) return [];
          window.Symbol &&
            Symbol.iterator &&
            Array.prototype.from &&
            n[Symbol.iterator] &&
            (n = Array.from(n)),
            Array.isArray(n) || (n = o(n));
          for (
            var r = n.map(function (n) {
                var r = {};
                for (var o in n) {
                  var a = n[o];
                  if ("offset" == o) {
                    if (null != a) {
                      if (!isFinite((a = Number(a))))
                        throw TypeError("Keyframe offsets must be numbers.");
                      if (a < 0 || a > 1)
                        throw TypeError(
                          "Keyframe offsets must be between 0 and 1."
                        );
                    }
                  } else if ("composite" == o) {
                    if ("add" == a || "accumulate" == a)
                      throw {
                        type: DOMException.NOT_SUPPORTED_ERR,
                        name: "NotSupportedError",
                        message: "add compositing is not supported",
                      };
                    if ("replace" != a)
                      throw TypeError("Invalid composite mode " + a + ".");
                  } else a = "easing" == o ? e.normalizeEasing(a) : "" + a;
                  i(o, a, r);
                }
                return (
                  null == r.offset && (r.offset = null),
                  null == r.easing && (r.easing = "linear"),
                  r
                );
              }),
              a = !0,
              s = -1 / 0,
              l = 0;
            l < r.length;
            l++
          ) {
            var u = r[l].offset;
            if (null != u) {
              if (u < s)
                throw TypeError(
                  "Keyframes are not loosely sorted by offset. Sort or specify offsets."
                );
              s = u;
            } else a = !1;
          }
          return (
            (r = r.filter(function (e) {
              return e.offset >= 0 && e.offset <= 1;
            })),
            a ||
              (function () {
                var e = r.length;
                null == r[e - 1].offset && (r[e - 1].offset = 1),
                  e > 1 && null == r[0].offset && (r[0].offset = 0);
                for (var n = 0, i = r[0].offset, o = 1; o < e; o++) {
                  var a = r[o].offset;
                  if (null != a) {
                    for (var s = 1; s < o - n; s++)
                      r[n + s].offset = i + ((a - i) * s) / (o - n);
                    (n = o), (i = a);
                  }
                }
              })(),
            r
          );
        });
    })(r),
    (n = {}),
    ((e = r).isDeprecated = function (e, r, i, o) {
      var a = new Date(),
        s = new Date(r);
      return (
        s.setMonth(s.getMonth() + 3),
        !(
          a < s &&
          (e in n ||
            console.warn(
              "Web Animations: " +
                e +
                " " +
                (o ? "are" : "is") +
                " deprecated and will stop working on " +
                s.toDateString() +
                ". " +
                i
            ),
          (n[e] = !0),
          1)
        )
      );
    }),
    (e.deprecated = function (n, r, i, o) {
      if (e.isDeprecated(n, r, i, o))
        throw Error(
          n + " " + (o ? "are" : "is") + " no longer supported. " + i
        );
    }),
    (function () {
      if (document.documentElement.animate) {
        var e,
          n,
          o,
          a,
          s,
          l,
          u,
          c,
          f,
          $,
          d,
          h = document.documentElement.animate([], 0),
          p = !0;
        if (
          (h &&
            ((p = !1),
            "play|currentTime|pause|reverse|playbackRate|cancel|finish|startTime|playState"
              .split("|")
              .forEach(function (e) {
                void 0 === h[e] && (p = !0);
              })),
          !p)
        )
          return;
      }
      (e = r),
        ((n = i).convertEffectInput = function (r) {
          var i = (function (e) {
              for (var n = {}, r = 0; r < e.length; r++)
                for (var i in e[r])
                  if ("offset" != i && "easing" != i && "composite" != i) {
                    var o = {
                      offset: e[r].offset,
                      easing: e[r].easing,
                      value: e[r][i],
                    };
                    (n[i] = n[i] || []), n[i].push(o);
                  }
              for (var a in n) {
                var s = n[a];
                if (0 != s[0].offset || 1 != s[s.length - 1].offset)
                  throw {
                    type: DOMException.NOT_SUPPORTED_ERR,
                    name: "NotSupportedError",
                    message: "Partial keyframes are not supported",
                  };
              }
              return n;
            })(e.normalizeKeyframes(r)),
            o = (function (r) {
              var i = [];
              for (var o in r)
                for (var a = r[o], s = 0; s < a.length - 1; s++) {
                  var l = s,
                    u = s + 1,
                    c = a[l].offset,
                    f = a[u].offset,
                    $ = c,
                    d = f;
                  0 == s && (($ = -1 / 0), 0 == f && (u = l)),
                    s == a.length - 2 && ((d = 1 / 0), 1 == c && (l = u)),
                    i.push({
                      applyFrom: $,
                      applyTo: d,
                      startOffset: a[l].offset,
                      endOffset: a[u].offset,
                      easingFunction: e.parseEasingFunction(a[l].easing),
                      property: o,
                      interpolation: n.propertyInterpolation(
                        o,
                        a[l].value,
                        a[u].value
                      ),
                    });
                }
              return (
                i.sort(function (e, n) {
                  return e.startOffset - n.startOffset;
                }),
                i
              );
            })(i);
          return function (e, r) {
            if (null != r)
              o.filter(function (e) {
                return r >= e.applyFrom && r < e.applyTo;
              }).forEach(function (i) {
                var o = r - i.startOffset,
                  a = i.endOffset - i.startOffset,
                  s = 0 == a ? 0 : i.easingFunction(o / a);
                n.apply(e, i.property, i.interpolation(s));
              });
            else
              for (var a in i)
                "offset" != a &&
                  "easing" != a &&
                  "composite" != a &&
                  n.clear(e, a);
          };
        }),
        (function (e, n, r) {
          function i(e) {
            return e.replace(/-(.)/g, function (e, n) {
              return n.toUpperCase();
            });
          }
          function o(e, n, r) {
            (a[r] = a[r] || []), a[r].push([e, n]);
          }
          var a = {};
          n.addPropertiesHandler = function (e, n, r) {
            for (var a = 0; a < r.length; a++) o(e, n, i(r[a]));
          };
          var s = {
            backgroundColor: "transparent",
            backgroundPosition: "0% 0%",
            borderBottomColor: "currentColor",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
            borderBottomWidth: "3px",
            borderLeftColor: "currentColor",
            borderLeftWidth: "3px",
            borderRightColor: "currentColor",
            borderRightWidth: "3px",
            borderSpacing: "2px",
            borderTopColor: "currentColor",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
            borderTopWidth: "3px",
            bottom: "auto",
            clip: "rect(0px, 0px, 0px, 0px)",
            color: "black",
            fontSize: "100%",
            fontWeight: "400",
            height: "auto",
            left: "auto",
            letterSpacing: "normal",
            lineHeight: "120%",
            marginBottom: "0px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "0px",
            maxHeight: "none",
            maxWidth: "none",
            minHeight: "0px",
            minWidth: "0px",
            opacity: "1.0",
            outlineColor: "invert",
            outlineOffset: "0px",
            outlineWidth: "3px",
            paddingBottom: "0px",
            paddingLeft: "0px",
            paddingRight: "0px",
            paddingTop: "0px",
            right: "auto",
            strokeDasharray: "none",
            strokeDashoffset: "0px",
            textIndent: "0px",
            textShadow: "0px 0px 0px transparent",
            top: "auto",
            transform: "",
            verticalAlign: "0px",
            visibility: "visible",
            width: "auto",
            wordSpacing: "normal",
            zIndex: "auto",
          };
          n.propertyInterpolation = function (r, o, l) {
            var u = r;
            /-/.test(r) &&
              !e.isDeprecated(
                "Hyphenated property names",
                "2016-03-22",
                "Use camelCase instead.",
                !0
              ) &&
              (u = i(r)),
              ("initial" != o && "initial" != l) ||
                ("initial" == o && (o = s[u]), "initial" == l && (l = s[u]));
            for (var c = o == l ? [] : a[u], f = 0; c && f < c.length; f++) {
              var $ = c[f][0](o),
                d = c[f][0](l);
              if (void 0 !== $ && void 0 !== d) {
                var h = c[f][1]($, d);
                if (h) {
                  var p = n.Interpolation.apply(null, h);
                  return function (e) {
                    return 0 == e ? o : 1 == e ? l : p(e);
                  };
                }
              }
            }
            return n.Interpolation(!1, !0, function (e) {
              return e ? l : o;
            });
          };
        })(r, i),
        (o = r),
        ((a = i).KeyframeEffect = function (e, n, r, i) {
          var s,
            l,
            u,
            c,
            f =
              ((s = o.normalizeTimingInput(r)),
              (l = o.calculateActiveDuration(s)),
              ((u = function (e) {
                return o.calculateIterationProgress(l, e, s);
              })._totalDuration = s.delay + l + s.endDelay),
              u),
            $ = a.convertEffectInput(n),
            d = function () {
              $(e, c);
            };
          return (
            (d._update = function (e) {
              return null !== (c = f(e));
            }),
            (d._clear = function () {
              $(e, null);
            }),
            (d._hasSameTarget = function (n) {
              return e === n;
            }),
            (d._target = e),
            (d._totalDuration = f._totalDuration),
            (d._id = i),
            d
          );
        }),
        (function (e, n) {
          function r(e, n, r) {
            (r.enumerable = !0),
              (r.configurable = !0),
              Object.defineProperty(e, n, r);
          }
          function i(e) {
            var n, r;
            (this._element = e),
              (this._surrogateStyle = document.createElementNS(
                "http://www.w3.org/1999/xhtml",
                "div"
              ).style),
              (this._style = e.style),
              (this._length = 0),
              (this._isAnimatedProperty = {}),
              (this._updateSvgTransformAttr =
                ((n = window),
                !(
                  !(r = e).namespaceURI || -1 == r.namespaceURI.indexOf("/svg")
                ) &&
                  (o in n ||
                    (n[o] = /Trident|MSIE|IEMobile|Edge|Android 4/i.test(
                      n.navigator.userAgent
                    )),
                  n[o]))),
              (this._savedTransformAttr = null);
            for (var i = 0; i < this._style.length; i++) {
              var a = this._style[i];
              this._surrogateStyle[a] = this._style[a];
            }
            this._updateIndices();
          }
          var o = "_webAnimationsUpdateSvgTransformAttr",
            a = { cssText: 1, length: 1, parentRule: 1 },
            s = {
              getPropertyCSSValue: 1,
              getPropertyPriority: 1,
              getPropertyValue: 1,
              item: 1,
              removeProperty: 1,
              setProperty: 1,
            },
            l = { removeProperty: 1, setProperty: 1 };
          for (var u in ((i.prototype = {
            get cssText() {
              return this._surrogateStyle.cssText;
            },
            set cssText(t) {
              for (var c = {}, f = 0; f < this._surrogateStyle.length; f++)
                c[this._surrogateStyle[f]] = !0;
              for (
                this._surrogateStyle.cssText = t, this._updateIndices(), f = 0;
                f < this._surrogateStyle.length;
                f++
              )
                c[this._surrogateStyle[f]] = !0;
              for (var $ in c)
                this._isAnimatedProperty[$] ||
                  this._style.setProperty(
                    $,
                    this._surrogateStyle.getPropertyValue($)
                  );
            },
            get length() {
              return this._surrogateStyle.length;
            },
            get parentRule() {
              return this._style.parentRule;
            },
            _updateIndices: function () {
              for (; this._length < this._surrogateStyle.length; )
                Object.defineProperty(this, this._length, {
                  configurable: !0,
                  enumerable: !1,
                  get: (function (e) {
                    return function () {
                      return this._surrogateStyle[e];
                    };
                  })(this._length),
                }),
                  this._length++;
              for (; this._length > this._surrogateStyle.length; )
                this._length--,
                  Object.defineProperty(this, this._length, {
                    configurable: !0,
                    enumerable: !1,
                    value: void 0,
                  });
            },
            _set: function (n, r) {
              (this._style[n] = r),
                (this._isAnimatedProperty[n] = !0),
                this._updateSvgTransformAttr &&
                  "transform" == e.unprefixedPropertyName(n) &&
                  (null == this._savedTransformAttr &&
                    (this._savedTransformAttr =
                      this._element.getAttribute("transform")),
                  this._element.setAttribute(
                    "transform",
                    e.transformToSvgMatrix(r)
                  ));
            },
            _clear: function (n) {
              (this._style[n] = this._surrogateStyle[n]),
                this._updateSvgTransformAttr &&
                  "transform" == e.unprefixedPropertyName(n) &&
                  (this._savedTransformAttr
                    ? this._element.setAttribute(
                        "transform",
                        this._savedTransformAttr
                      )
                    : this._element.removeAttribute("transform"),
                  (this._savedTransformAttr = null)),
                delete this._isAnimatedProperty[n];
            },
          }),
          s))
            i.prototype[u] = (function (e, n) {
              return function () {
                var r = this._surrogateStyle[e].apply(
                  this._surrogateStyle,
                  arguments
                );
                return (
                  n &&
                    (this._isAnimatedProperty[arguments[0]] ||
                      this._style[e].apply(this._style, arguments),
                    this._updateIndices()),
                  r
                );
              };
            })(u, u in l);
          for (var d in document.documentElement.style)
            d in a ||
              d in s ||
              (function (e) {
                r(i.prototype, e, {
                  get: function () {
                    return this._surrogateStyle[e];
                  },
                  set: function (n) {
                    (this._surrogateStyle[e] = n),
                      this._updateIndices(),
                      this._isAnimatedProperty[e] || (this._style[e] = n);
                  },
                });
              })(d);
          (e.apply = function (n, o, a) {
            (function (e) {
              if (!e._webAnimationsPatchedStyle) {
                var n = new i(e);
                try {
                  r(e, "style", {
                    get: function () {
                      return n;
                    },
                  });
                } catch (o) {
                  (e.style._set = function (n, r) {
                    e.style[n] = r;
                  }),
                    (e.style._clear = function (n) {
                      e.style[n] = "";
                    });
                }
                e._webAnimationsPatchedStyle = e.style;
              }
            })(n),
              n.style._set(e.propertyName(o), a);
          }),
            (e.clear = function (n, r) {
              n._webAnimationsPatchedStyle && n.style._clear(e.propertyName(r));
            });
        })(i),
        (s = i),
        (window.Element.prototype.animate = function (e, n) {
          var r = "";
          return (
            n && n.id && (r = n.id),
            s.timeline._play(s.KeyframeEffect(this, e, n, r))
          );
        }),
        (i.Interpolation = function (e, n, r) {
          return function (i) {
            return r(
              (function e(n, r, i) {
                if ("number" == typeof n && "number" == typeof r)
                  return n * (1 - i) + r * i;
                if ("boolean" == typeof n && "boolean" == typeof r)
                  return i < 0.5 ? n : r;
                if (n.length == r.length) {
                  for (var o = [], a = 0; a < n.length; a++)
                    o.push(e(n[a], r[a], i));
                  return o;
                }
                throw "Mismatched interpolation arguments " + n + ":" + r;
              })(e, n, i)
            );
          };
        }),
        (u = i),
        (c = (function () {
          function e(e, n) {
            for (
              var r = [
                  [0, 0, 0, 0],
                  [0, 0, 0, 0],
                  [0, 0, 0, 0],
                  [0, 0, 0, 0],
                ],
                i = 0;
              i < 4;
              i++
            )
              for (var o = 0; o < 4; o++)
                for (var a = 0; a < 4; a++) r[i][o] += n[i][a] * e[a][o];
            return r;
          }
          return function (n, r, i, o, a) {
            for (
              var s = [
                  [1, 0, 0, 0],
                  [0, 1, 0, 0],
                  [0, 0, 1, 0],
                  [0, 0, 0, 1],
                ],
                l = 0;
              l < 4;
              l++
            )
              s[l][3] = a[l];
            for (l = 0; l < 3; l++)
              for (var u = 0; u < 3; u++) s[3][l] += n[u] * s[u][l];
            var c = o[0],
              f = o[1],
              $ = o[2],
              d = o[3],
              h = [
                [1, 0, 0, 0],
                [0, 1, 0, 0],
                [0, 0, 1, 0],
                [0, 0, 0, 1],
              ];
            (h[0][0] = 1 - 2 * (f * f + $ * $)),
              (h[0][1] = 2 * (c * f - $ * d)),
              (h[0][2] = 2 * (c * $ + f * d)),
              (h[1][0] = 2 * (c * f + $ * d)),
              (h[1][1] = 1 - 2 * (c * c + $ * $)),
              (h[1][2] = 2 * (f * $ - c * d)),
              (h[2][0] = 2 * (c * $ - f * d)),
              (h[2][1] = 2 * (f * $ + c * d)),
              (h[2][2] = 1 - 2 * (c * c + f * f)),
              (s = e(s, h));
            var p,
              m = [
                [1, 0, 0, 0],
                [0, 1, 0, 0],
                [0, 0, 1, 0],
                [0, 0, 0, 1],
              ];
            for (
              i[2] && ((m[2][1] = i[2]), (s = e(s, m))),
                i[1] && ((m[2][1] = 0), (m[2][0] = i[0]), (s = e(s, m))),
                i[0] && ((m[2][0] = 0), (m[1][0] = i[0]), (s = e(s, m))),
                l = 0;
              l < 3;
              l++
            )
              for (u = 0; u < 3; u++) s[l][u] *= r[l];
            return 0 == (p = s)[0][2] &&
              0 == p[0][3] &&
              0 == p[1][2] &&
              0 == p[1][3] &&
              0 == p[2][0] &&
              0 == p[2][1] &&
              1 == p[2][2] &&
              0 == p[2][3] &&
              0 == p[3][2] &&
              1 == p[3][3]
              ? [s[0][0], s[0][1], s[1][0], s[1][1], s[3][0], s[3][1]]
              : s[0].concat(s[1], s[2], s[3]);
          };
        })()),
        (u.composeMatrix = c),
        (u.quat = function (e, n, r) {
          var i,
            o = u.dot(e, n);
          o = Math.max(Math.min((i = o), 1), -1);
          var a = [];
          if (1 === o) a = e;
          else
            for (
              var s = Math.acos(o),
                l = (1 * Math.sin(r * s)) / Math.sqrt(1 - o * o),
                c = 0;
              c < 4;
              c++
            )
              a.push(e[c] * (Math.cos(r * s) - o * l) + n[c] * l);
          return a;
        }),
        (f = r),
        ($ = i),
        (f.sequenceNumber = 0),
        (d = function (e, n, r) {
          (this.target = e),
            (this.currentTime = n),
            (this.timelineTime = r),
            (this.type = "finish"),
            (this.bubbles = !1),
            (this.cancelable = !1),
            (this.currentTarget = e),
            (this.defaultPrevented = !1),
            (this.eventPhase = Event.AT_TARGET),
            (this.timeStamp = Date.now());
        }),
        ($.Animation = function (e) {
          (this.id = ""),
            e && e._id && (this.id = e._id),
            (this._sequenceNumber = f.sequenceNumber++),
            (this._currentTime = 0),
            (this._startTime = null),
            (this._paused = !1),
            (this._playbackRate = 1),
            (this._inTimeline = !0),
            (this._finishedFlag = !0),
            (this.onfinish = null),
            (this._finishHandlers = []),
            (this._effect = e),
            (this._inEffect = this._effect._update(0)),
            (this._idle = !0),
            (this._currentTimePending = !1);
        }),
        ($.Animation.prototype = {
          _ensureAlive: function () {
            this.playbackRate < 0 && 0 === this.currentTime
              ? (this._inEffect = this._effect._update(-1))
              : (this._inEffect = this._effect._update(this.currentTime)),
              this._inTimeline ||
                (!this._inEffect && this._finishedFlag) ||
                ((this._inTimeline = !0), $.timeline._animations.push(this));
          },
          _tickCurrentTime: function (e, n) {
            e != this._currentTime &&
              ((this._currentTime = e),
              this._isFinished &&
                !n &&
                (this._currentTime =
                  this._playbackRate > 0 ? this._totalDuration : 0),
              this._ensureAlive());
          },
          get currentTime() {
            return this._idle || this._currentTimePending
              ? null
              : this._currentTime;
          },
          set currentTime(t) {
            isNaN((t = +t)) ||
              ($.restart(),
              this._paused ||
                null == this._startTime ||
                (this._startTime =
                  this._timeline.currentTime - t / this._playbackRate),
              (this._currentTimePending = !1),
              this._currentTime != t &&
                (this._idle && ((this._idle = !1), (this._paused = !0)),
                this._tickCurrentTime(t, !0),
                $.applyDirtiedAnimation(this)));
          },
          get startTime() {
            return this._startTime;
          },
          set startTime(t) {
            isNaN((t = +t)) ||
              this._paused ||
              this._idle ||
              ((this._startTime = t),
              this._tickCurrentTime(
                (this._timeline.currentTime - this._startTime) *
                  this.playbackRate
              ),
              $.applyDirtiedAnimation(this));
          },
          get playbackRate() {
            return this._playbackRate;
          },
          set playbackRate(t) {
            if (t != this._playbackRate) {
              var m = this.currentTime;
              (this._playbackRate = t),
                (this._startTime = null),
                "paused" != this.playState &&
                  "idle" != this.playState &&
                  ((this._finishedFlag = !1),
                  (this._idle = !1),
                  this._ensureAlive(),
                  $.applyDirtiedAnimation(this)),
                null != m && (this.currentTime = m);
            }
          },
          get _isFinished() {
            return (
              !this._idle &&
              ((this._playbackRate > 0 &&
                this._currentTime >= this._totalDuration) ||
                (this._playbackRate < 0 && this._currentTime <= 0))
            );
          },
          get _totalDuration() {
            return this._effect._totalDuration;
          },
          get playState() {
            return this._idle
              ? "idle"
              : (null == this._startTime &&
                  !this._paused &&
                  0 != this.playbackRate) ||
                this._currentTimePending
              ? "pending"
              : this._paused
              ? "paused"
              : this._isFinished
              ? "finished"
              : "running";
          },
          _rewind: function () {
            if (this._playbackRate >= 0) this._currentTime = 0;
            else {
              if (!(this._totalDuration < 1 / 0))
                throw new DOMException(
                  "Unable to rewind negative playback rate animation with infinite duration",
                  "InvalidStateError"
                );
              this._currentTime = this._totalDuration;
            }
          },
          play: function () {
            (this._paused = !1),
              (this._isFinished || this._idle) &&
                (this._rewind(), (this._startTime = null)),
              (this._finishedFlag = !1),
              (this._idle = !1),
              this._ensureAlive(),
              $.applyDirtiedAnimation(this);
          },
          pause: function () {
            this._isFinished || this._paused || this._idle
              ? this._idle && (this._rewind(), (this._idle = !1))
              : (this._currentTimePending = !0),
              (this._startTime = null),
              (this._paused = !0);
          },
          finish: function () {
            this._idle ||
              ((this.currentTime =
                this._playbackRate > 0 ? this._totalDuration : 0),
              (this._startTime = this._totalDuration - this.currentTime),
              (this._currentTimePending = !1),
              $.applyDirtiedAnimation(this));
          },
          cancel: function () {
            this._inEffect &&
              ((this._inEffect = !1),
              (this._idle = !0),
              (this._paused = !1),
              (this._finishedFlag = !0),
              (this._currentTime = 0),
              (this._startTime = null),
              this._effect._update(null),
              $.applyDirtiedAnimation(this));
          },
          reverse: function () {
            (this.playbackRate *= -1), this.play();
          },
          addEventListener: function (e, n) {
            "function" == typeof n &&
              "finish" == e &&
              this._finishHandlers.push(n);
          },
          removeEventListener: function (e, n) {
            if ("finish" == e) {
              var r = this._finishHandlers.indexOf(n);
              r >= 0 && this._finishHandlers.splice(r, 1);
            }
          },
          _fireEvents: function (e) {
            if (this._isFinished) {
              if (!this._finishedFlag) {
                var n = new d(this, this._currentTime, e),
                  r = this._finishHandlers.concat(
                    this.onfinish ? [this.onfinish] : []
                  );
                setTimeout(function () {
                  r.forEach(function (e) {
                    e.call(n.target, n);
                  });
                }, 0),
                  (this._finishedFlag = !0);
              }
            } else this._finishedFlag = !1;
          },
          _tick: function (e, n) {
            this._idle ||
              this._paused ||
              (null == this._startTime
                ? n &&
                  (this.startTime = e - this._currentTime / this.playbackRate)
                : this._isFinished ||
                  this._tickCurrentTime(
                    (e - this._startTime) * this.playbackRate
                  )),
              n && ((this._currentTimePending = !1), this._fireEvents(e));
          },
          get _needsTick() {
            return (
              this.playState in { pending: 1, running: 1 } ||
              !this._finishedFlag
            );
          },
          _targetAnimations: function () {
            var e = this._effect._target;
            return (
              e._activeAnimations || (e._activeAnimations = []),
              e._activeAnimations
            );
          },
          _markTarget: function () {
            var e = this._targetAnimations();
            -1 === e.indexOf(this) && e.push(this);
          },
          _unmarkTarget: function () {
            var e = this._targetAnimations(),
              n = e.indexOf(this);
            -1 !== n && e.splice(n, 1);
          },
        }),
        (function (e, n, r) {
          function i(e) {
            var n = c;
            (c = []),
              e < m.currentTime && (e = m.currentTime),
              m._animations.sort(o),
              (m._animations = l(e, !0, m._animations)[0]),
              n.forEach(function (n) {
                n[1](e);
              }),
              s();
          }
          function o(e, n) {
            return e._sequenceNumber - n._sequenceNumber;
          }
          function a() {
            (this._animations = []),
              (this.currentTime =
                window.performance && performance.now ? performance.now() : 0);
          }
          function s() {
            h.forEach(function (e) {
              e();
            }),
              (h.length = 0);
          }
          function l(e, r, i) {
            (p = !0), (d = !1), (n.timeline.currentTime = e), ($ = !1);
            var o = [],
              a = [],
              s = [],
              l = [];
            return (
              i.forEach(function (n) {
                n._tick(e, r),
                  n._inEffect
                    ? (a.push(n._effect), n._markTarget())
                    : (o.push(n._effect), n._unmarkTarget()),
                  n._needsTick && ($ = !0);
                var i = n._inEffect || n._needsTick;
                (n._inTimeline = i), i ? s.push(n) : l.push(n);
              }),
              h.push.apply(h, o),
              h.push.apply(h, a),
              $ && requestAnimationFrame(function () {}),
              (p = !1),
              [s, l]
            );
          }
          var u = window.requestAnimationFrame,
            c = [],
            f = 0;
          (window.requestAnimationFrame = function (e) {
            var n = f++;
            return 0 == c.length && u(i), c.push([n, e]), n;
          }),
            (window.cancelAnimationFrame = function (e) {
              c.forEach(function (n) {
                n[0] == e && (n[1] = function () {});
              });
            }),
            (a.prototype = {
              _play: function (r) {
                r._timing = e.normalizeTimingInput(r.timing);
                var i = new n.Animation(r);
                return (
                  (i._idle = !1),
                  (i._timeline = this),
                  this._animations.push(i),
                  n.restart(),
                  n.applyDirtiedAnimation(i),
                  i
                );
              },
            });
          var $ = !1,
            d = !1;
          (n.restart = function () {
            return (
              $ || (($ = !0), requestAnimationFrame(function () {}), (d = !0)),
              d
            );
          }),
            (n.applyDirtiedAnimation = function (e) {
              if (!p) {
                e._markTarget();
                var r = e._targetAnimations();
                r.sort(o),
                  l(n.timeline.currentTime, !1, r.slice())[1].forEach(function (
                    e
                  ) {
                    var n = m._animations.indexOf(e);
                    -1 !== n && m._animations.splice(n, 1);
                  }),
                  s();
              }
            });
          var h = [],
            p = !1,
            m = new a();
          n.timeline = m;
        })(r, i),
        (function (e, n) {
          function r(e, n) {
            for (var r = 0, i = 0; i < e.length; i++) r += e[i] * n[i];
            return r;
          }
          function i(e, n) {
            return [
              e[0] * n[0] + e[4] * n[1] + e[8] * n[2] + e[12] * n[3],
              e[1] * n[0] + e[5] * n[1] + e[9] * n[2] + e[13] * n[3],
              e[2] * n[0] + e[6] * n[1] + e[10] * n[2] + e[14] * n[3],
              e[3] * n[0] + e[7] * n[1] + e[11] * n[2] + e[15] * n[3],
              e[0] * n[4] + e[4] * n[5] + e[8] * n[6] + e[12] * n[7],
              e[1] * n[4] + e[5] * n[5] + e[9] * n[6] + e[13] * n[7],
              e[2] * n[4] + e[6] * n[5] + e[10] * n[6] + e[14] * n[7],
              e[3] * n[4] + e[7] * n[5] + e[11] * n[6] + e[15] * n[7],
              e[0] * n[8] + e[4] * n[9] + e[8] * n[10] + e[12] * n[11],
              e[1] * n[8] + e[5] * n[9] + e[9] * n[10] + e[13] * n[11],
              e[2] * n[8] + e[6] * n[9] + e[10] * n[10] + e[14] * n[11],
              e[3] * n[8] + e[7] * n[9] + e[11] * n[10] + e[15] * n[11],
              e[0] * n[12] + e[4] * n[13] + e[8] * n[14] + e[12] * n[15],
              e[1] * n[12] + e[5] * n[13] + e[9] * n[14] + e[13] * n[15],
              e[2] * n[12] + e[6] * n[13] + e[10] * n[14] + e[14] * n[15],
              e[3] * n[12] + e[7] * n[13] + e[11] * n[14] + e[15] * n[15],
            ];
          }
          function o(e) {
            var n = e.rad || 0;
            return (
              ((e.deg || 0) / 360 + (e.grad || 0) / 400 + (e.turn || 0)) *
                (2 * Math.PI) +
              n
            );
          }
          function a(e) {
            switch (e.t) {
              case "rotatex":
                var n = o(e.d[0]);
                return [
                  1,
                  0,
                  0,
                  0,
                  0,
                  Math.cos(n),
                  Math.sin(n),
                  0,
                  0,
                  -Math.sin(n),
                  Math.cos(n),
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "rotatey":
                return [
                  Math.cos((n = o(e.d[0]))),
                  0,
                  -Math.sin(n),
                  0,
                  0,
                  1,
                  0,
                  0,
                  Math.sin(n),
                  0,
                  Math.cos(n),
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "rotate":
              case "rotatez":
                return [
                  Math.cos((n = o(e.d[0]))),
                  Math.sin(n),
                  0,
                  0,
                  -Math.sin(n),
                  Math.cos(n),
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "rotate3d":
                var r = e.d[0],
                  i = e.d[1],
                  a = e.d[2],
                  s = ((n = o(e.d[3])), r * r + i * i + a * a);
                if (0 === s) (r = 1), (i = 0), (a = 0);
                else if (1 !== s) {
                  var l = Math.sqrt(s);
                  (r /= l), (i /= l), (a /= l);
                }
                var u = Math.sin(n / 2),
                  c = u * Math.cos(n / 2),
                  f = u * u;
                return [
                  1 - 2 * (i * i + a * a) * f,
                  2 * (r * i * f + a * c),
                  2 * (r * a * f - i * c),
                  0,
                  2 * (r * i * f - a * c),
                  1 - 2 * (r * r + a * a) * f,
                  2 * (i * a * f + r * c),
                  0,
                  2 * (r * a * f + i * c),
                  2 * (i * a * f - r * c),
                  1 - 2 * (r * r + i * i) * f,
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "scale":
                return [
                  e.d[0],
                  0,
                  0,
                  0,
                  0,
                  e.d[1],
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "scalex":
                return [e.d[0], 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
              case "scaley":
                return [1, 0, 0, 0, 0, e.d[0], 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
              case "scalez":
                return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, e.d[0], 0, 0, 0, 0, 1];
              case "scale3d":
                return [
                  e.d[0],
                  0,
                  0,
                  0,
                  0,
                  e.d[1],
                  0,
                  0,
                  0,
                  0,
                  e.d[2],
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "skew":
                var $ = o(e.d[0]);
                return [
                  1,
                  Math.tan(o(e.d[1])),
                  0,
                  0,
                  Math.tan($),
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "skewx":
                return [
                  1,
                  0,
                  0,
                  0,
                  Math.tan((n = o(e.d[0]))),
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "skewy":
                return [
                  1,
                  Math.tan((n = o(e.d[0]))),
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "translate":
                return [
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  (r = e.d[0].px || 0),
                  (i = e.d[1].px || 0),
                  0,
                  1,
                ];
              case "translatex":
                return [
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  (r = e.d[0].px || 0),
                  0,
                  0,
                  1,
                ];
              case "translatey":
                return [
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  (i = e.d[0].px || 0),
                  0,
                  1,
                ];
              case "translatez":
                return [
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  (a = e.d[0].px || 0),
                  1,
                ];
              case "translate3d":
                return [
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  (r = e.d[0].px || 0),
                  (i = e.d[1].px || 0),
                  (a = e.d[2].px || 0),
                  1,
                ];
              case "perspective":
                return [
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  0,
                  1,
                  e.d[0].px ? -1 / e.d[0].px : 0,
                  0,
                  0,
                  0,
                  1,
                ];
              case "matrix":
                return [
                  e.d[0],
                  e.d[1],
                  0,
                  0,
                  e.d[2],
                  e.d[3],
                  0,
                  0,
                  0,
                  0,
                  1,
                  0,
                  e.d[4],
                  e.d[5],
                  0,
                  1,
                ];
              case "matrix3d":
                return e.d;
            }
          }
          function s(e) {
            return 0 === e.length
              ? [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
              : e.map(a).reduce(i);
          }
          var l = (function () {
            function e(e) {
              return (
                e[0][0] * e[1][1] * e[2][2] +
                e[1][0] * e[2][1] * e[0][2] +
                e[2][0] * e[0][1] * e[1][2] -
                e[0][2] * e[1][1] * e[2][0] -
                e[1][2] * e[2][1] * e[0][0] -
                e[2][2] * e[0][1] * e[1][0]
              );
            }
            function n(e) {
              var n = i(e);
              return [e[0] / n, e[1] / n, e[2] / n];
            }
            function i(e) {
              return Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
            }
            function o(e, n, r, i) {
              return [
                r * e[0] + i * n[0],
                r * e[1] + i * n[1],
                r * e[2] + i * n[2],
              ];
            }
            return function (a) {
              var s = [
                a.slice(0, 4),
                a.slice(4, 8),
                a.slice(8, 12),
                a.slice(12, 16),
              ];
              if (1 !== s[3][3]) return null;
              for (var l = [], u = 0; u < 4; u++) l.push(s[u].slice());
              for (u = 0; u < 3; u++) l[u][3] = 0;
              if (0 === e(l)) return null;
              var c,
                f,
                $ = [];
              s[0][3] || s[1][3] || s[2][3]
                ? ($.push(s[0][3]),
                  $.push(s[1][3]),
                  $.push(s[2][3]),
                  $.push(s[3][3]),
                  (c = (function (e, n) {
                    for (var r = [], i = 0; i < 4; i++) {
                      for (var o = 0, a = 0; a < 4; a++) o += e[a] * n[a][i];
                      r.push(o);
                    }
                    return r;
                  })($, [
                    [
                      (f = (function (n) {
                        for (
                          var r = 1 / e(n),
                            i = n[0][0],
                            o = n[0][1],
                            a = n[0][2],
                            s = n[1][0],
                            l = n[1][1],
                            u = n[1][2],
                            c = n[2][0],
                            f = n[2][1],
                            $ = n[2][2],
                            d = [
                              [
                                (l * $ - u * f) * r,
                                (a * f - o * $) * r,
                                (o * u - a * l) * r,
                                0,
                              ],
                              [
                                (u * c - s * $) * r,
                                (i * $ - a * c) * r,
                                (a * s - i * u) * r,
                                0,
                              ],
                              [
                                (s * f - l * c) * r,
                                (c * o - i * f) * r,
                                (i * l - o * s) * r,
                                0,
                              ],
                            ],
                            h = [],
                            p = 0;
                          p < 3;
                          p++
                        ) {
                          for (var m = 0, g = 0; g < 3; g++)
                            m += n[3][g] * d[g][p];
                          h.push(m);
                        }
                        return h.push(1), d.push(h), d;
                      })(l))[0][0],
                      f[1][0],
                      f[2][0],
                      f[3][0],
                    ],
                    [f[0][1], f[1][1], f[2][1], f[3][1]],
                    [f[0][2], f[1][2], f[2][2], f[3][2]],
                    [f[0][3], f[1][3], f[2][3], f[3][3]],
                  ])))
                : (c = [0, 0, 0, 1]);
              var d = s[3].slice(0, 3),
                h = [];
              h.push(s[0].slice(0, 3));
              var p = [];
              p.push(i(h[0])), (h[0] = n(h[0]));
              var m,
                g,
                _ = [];
              h.push(s[1].slice(0, 3)),
                _.push(r(h[0], h[1])),
                (h[1] = o(h[1], h[0], 1, -_[0])),
                p.push(i(h[1])),
                (h[1] = n(h[1])),
                (_[0] /= p[1]),
                h.push(s[2].slice(0, 3)),
                _.push(r(h[0], h[2])),
                (h[2] = o(h[2], h[0], 1, -_[1])),
                _.push(r(h[1], h[2])),
                (h[2] = o(h[2], h[1], 1, -_[2])),
                p.push(i(h[2])),
                (h[2] = n(h[2])),
                (_[1] /= p[2]),
                (_[2] /= p[2]);
              var v =
                ((m = h[1]),
                (g = h[2]),
                [
                  m[1] * g[2] - m[2] * g[1],
                  m[2] * g[0] - m[0] * g[2],
                  m[0] * g[1] - m[1] * g[0],
                ]);
              if (0 > r(h[0], v))
                for (u = 0; u < 3; u++)
                  (p[u] *= -1),
                    (h[u][0] *= -1),
                    (h[u][1] *= -1),
                    (h[u][2] *= -1);
              var b,
                y,
                T = h[0][0] + h[1][1] + h[2][2] + 1;
              return (
                T > 1e-4
                  ? ((b = 0.5 / Math.sqrt(T)),
                    (y = [
                      (h[2][1] - h[1][2]) * b,
                      (h[0][2] - h[2][0]) * b,
                      (h[1][0] - h[0][1]) * b,
                      0.25 / b,
                    ]))
                  : h[0][0] > h[1][1] && h[0][0] > h[2][2]
                  ? (y = [
                      0.25 *
                        (b = 2 * Math.sqrt(1 + h[0][0] - h[1][1] - h[2][2])),
                      (h[0][1] + h[1][0]) / b,
                      (h[0][2] + h[2][0]) / b,
                      (h[2][1] - h[1][2]) / b,
                    ])
                  : h[1][1] > h[2][2]
                  ? ((b = 2 * Math.sqrt(1 + h[1][1] - h[0][0] - h[2][2])),
                    (y = [
                      (h[0][1] + h[1][0]) / b,
                      0.25 * b,
                      (h[1][2] + h[2][1]) / b,
                      (h[0][2] - h[2][0]) / b,
                    ]))
                  : ((b = 2 * Math.sqrt(1 + h[2][2] - h[0][0] - h[1][1])),
                    (y = [
                      (h[0][2] + h[2][0]) / b,
                      (h[1][2] + h[2][1]) / b,
                      0.25 * b,
                      (h[1][0] - h[0][1]) / b,
                    ])),
                [d, p, _, y, c]
              );
            };
          })();
          (e.dot = r),
            (e.makeMatrixDecomposition = function (e) {
              return [l(s(e))];
            }),
            (e.transformListToMatrix = s);
        })(i),
        (function (e) {
          function n(e, n) {
            var r = e.exec(n);
            if (r)
              return [
                (r = e.ignoreCase ? r[0].toLowerCase() : r[0]),
                n.substr(r.length),
              ];
          }
          function r(e, n) {
            var r = e((n = n.replace(/^\s*/, "")));
            if (r) return [r[0], r[1].replace(/^\s*/, "")];
          }
          function i(e, n, r, i, o) {
            for (
              var a = [],
                s = [],
                l = [],
                u = (function (e, n) {
                  for (var r = e, i = n; r && i; ) r > i ? (r %= i) : (i %= r);
                  return (e * n) / (r + i);
                })(i.length, o.length),
                c = 0;
              c < u;
              c++
            ) {
              var f = n(i[c % i.length], o[c % o.length]);
              if (!f) return;
              a.push(f[0]), s.push(f[1]), l.push(f[2]);
            }
            return [
              a,
              s,
              function (n) {
                var i = n
                  .map(function (e, n) {
                    return l[n](e);
                  })
                  .join(r);
                return e ? e(i) : i;
              },
            ];
          }
          (e.consumeToken = n),
            (e.consumeTrimmed = r),
            (e.consumeRepeated = function (e, i, o) {
              e = r.bind(null, e);
              for (var a = []; ; ) {
                var s = e(o);
                if (!s || (a.push(s[0]), !(s = n(i, (o = s[1]))) || "" == s[1]))
                  return [a, o];
                o = s[1];
              }
            }),
            (e.consumeParenthesised = function (e, n) {
              for (
                var r = 0, i = 0;
                i < n.length && (!/\s|,/.test(n[i]) || 0 != r);
                i++
              )
                if ("(" == n[i]) r++;
                else if (")" == n[i] && (0 == --r && i++, r <= 0)) break;
              var o = e(n.substr(0, i));
              return null == o ? void 0 : [o, n.substr(i)];
            }),
            (e.ignore = function (e) {
              return function (n) {
                var r = e(n);
                return r && (r[0] = void 0), r;
              };
            }),
            (e.optional = function (e, n) {
              return function (r) {
                return e(r) || [n, r];
              };
            }),
            (e.consumeList = function (n, r) {
              for (var i = [], o = 0; o < n.length; o++) {
                var a = e.consumeTrimmed(n[o], r);
                if (!a || "" == a[0]) return;
                void 0 !== a[0] && i.push(a[0]), (r = a[1]);
              }
              if ("" == r) return i;
            }),
            (e.mergeNestedRepeated = i.bind(null, null)),
            (e.mergeWrappedNestedRepeated = i),
            (e.mergeList = function (e, n, r) {
              for (var i = [], o = [], a = [], s = 0, l = 0; l < r.length; l++)
                if ("function" == typeof r[l]) {
                  var u = r[l](e[s], n[s++]);
                  i.push(u[0]), o.push(u[1]), a.push(u[2]);
                } else
                  !(function (e) {
                    i.push(!1),
                      o.push(!1),
                      a.push(function () {
                        return r[e];
                      });
                  })(l);
              return [
                i,
                o,
                function (e) {
                  for (var n = "", r = 0; r < e.length; r++) n += a[r](e[r]);
                  return n;
                },
              ];
            });
        })(i),
        (function (e) {
          function n(n) {
            var r = { inset: !1, lengths: [], color: null },
              i = e.consumeRepeated(
                function (n) {
                  var i = e.consumeToken(/^inset/i, n);
                  return i
                    ? ((r.inset = !0), i)
                    : (i = e.consumeLengthOrPercent(n))
                    ? (r.lengths.push(i[0]), i)
                    : (i = e.consumeColor(n))
                    ? ((r.color = i[0]), i)
                    : void 0;
                },
                /^/,
                n
              );
            if (i && i[0].length) return [r, i[1]];
          }
          var r = function (n, r, i, o) {
            function a(e) {
              return {
                inset: e,
                color: [0, 0, 0, 0],
                lengths: [{ px: 0 }, { px: 0 }, { px: 0 }, { px: 0 }],
              };
            }
            for (var s = [], l = [], u = 0; u < i.length || u < o.length; u++) {
              var c = i[u] || a(o[u].inset),
                f = o[u] || a(i[u].inset);
              s.push(c), l.push(f);
            }
            return e.mergeNestedRepeated(n, r, s, l);
          }.bind(
            null,
            function (n, r) {
              for (
                ;
                n.lengths.length < Math.max(n.lengths.length, r.lengths.length);

              )
                n.lengths.push({ px: 0 });
              for (
                ;
                r.lengths.length < Math.max(n.lengths.length, r.lengths.length);

              )
                r.lengths.push({ px: 0 });
              if (n.inset == r.inset && !!n.color == !!r.color) {
                for (
                  var i, o = [], a = [[], 0], s = [[], 0], l = 0;
                  l < n.lengths.length;
                  l++
                ) {
                  var u = e.mergeDimensions(n.lengths[l], r.lengths[l], 2 == l);
                  a[0].push(u[0]), s[0].push(u[1]), o.push(u[2]);
                }
                if (n.color && r.color) {
                  var c = e.mergeColors(n.color, r.color);
                  (a[1] = c[0]), (s[1] = c[1]), (i = c[2]);
                }
                return [
                  a,
                  s,
                  function (e) {
                    for (
                      var r = n.inset ? "inset " : " ", a = 0;
                      a < o.length;
                      a++
                    )
                      r += o[a](e[0][a]) + " ";
                    return i && (r += i(e[1])), r;
                  },
                ];
              }
            },
            ", "
          );
          e.addPropertiesHandler(
            function (r) {
              var i = e.consumeRepeated(n, /^,/, r);
              if (i && "" == i[1]) return i[0];
            },
            r,
            ["box-shadow", "text-shadow"]
          );
        })(i),
        (function (e, n) {
          function r(e) {
            return e.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
          }
          function i(e, n, r) {
            return Math.min(n, Math.max(e, r));
          }
          function o(e) {
            if (/^\s*[-+]?(\d*\.)?\d+\s*$/.test(e)) return Number(e);
          }
          function a(e, n) {
            return function (o, a) {
              return [
                o,
                a,
                function (o) {
                  return r(i(e, n, o));
                },
              ];
            };
          }
          function s(e) {
            var n = e.trim().split(/\s*[\s,]\s*/);
            if (0 !== n.length) {
              for (var r = [], i = 0; i < n.length; i++) {
                var a = o(n[i]);
                if (void 0 === a) return;
                r.push(a);
              }
              return r;
            }
          }
          (e.clamp = i),
            e.addPropertiesHandler(
              s,
              function (e, n) {
                if (e.length == n.length)
                  return [
                    e,
                    n,
                    function (e) {
                      return e.map(r).join(" ");
                    },
                  ];
              },
              ["stroke-dasharray"]
            ),
            e.addPropertiesHandler(o, a(0, 1 / 0), [
              "border-image-width",
              "line-height",
            ]),
            e.addPropertiesHandler(o, a(0, 1), [
              "opacity",
              "shape-image-threshold",
            ]),
            e.addPropertiesHandler(
              o,
              function (e, n) {
                if (0 != e) return a(0, 1 / 0)(e, n);
              },
              ["flex-grow", "flex-shrink"]
            ),
            e.addPropertiesHandler(
              o,
              function (e, n) {
                return [
                  e,
                  n,
                  function (e) {
                    return Math.round(i(1, 1 / 0, e));
                  },
                ];
              },
              ["orphans", "widows"]
            ),
            e.addPropertiesHandler(
              o,
              function (e, n) {
                return [e, n, Math.round];
              },
              ["z-index"]
            ),
            (e.parseNumber = o),
            (e.parseNumberList = s),
            (e.mergeNumbers = function (e, n) {
              return [e, n, r];
            }),
            (e.numberToString = r);
        })(i),
        (function (e, n) {
          e.addPropertiesHandler(
            String,
            function (e, n) {
              if ("visible" == e || "visible" == n)
                return [
                  0,
                  1,
                  function (r) {
                    return r <= 0 ? e : r >= 1 ? n : "visible";
                  },
                ];
            },
            ["visibility"]
          );
        })(i),
        (function (e, n) {
          function r(e) {
            (e = e.trim()), (a.fillStyle = "#000"), (a.fillStyle = e);
            var n = a.fillStyle;
            if (((a.fillStyle = "#fff"), (a.fillStyle = e), n == a.fillStyle)) {
              a.fillRect(0, 0, 1, 1);
              var r = a.getImageData(0, 0, 1, 1).data;
              a.clearRect(0, 0, 1, 1);
              var i = r[3] / 255;
              return [r[0] * i, r[1] * i, r[2] * i, i];
            }
          }
          function i(n, r) {
            return [
              n,
              r,
              function (n) {
                if (n[3])
                  for (var r, i = 0; i < 3; i++)
                    n[i] = Math.round(
                      Math.max(0, Math.min(255, (r = n[i] / n[3])))
                    );
                return (
                  (n[3] = e.numberToString(e.clamp(0, 1, n[3]))),
                  "rgba(" + n.join(",") + ")"
                );
              },
            ];
          }
          var o = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "canvas"
          );
          o.width = o.height = 1;
          var a = o.getContext("2d");
          e.addPropertiesHandler(r, i, [
            "background-color",
            "border-bottom-color",
            "border-left-color",
            "border-right-color",
            "border-top-color",
            "color",
            "fill",
            "flood-color",
            "lighting-color",
            "outline-color",
            "stop-color",
            "stroke",
            "text-decoration-color",
          ]),
            (e.consumeColor = e.consumeParenthesised.bind(null, r)),
            (e.mergeColors = i);
        })(i),
        (function (e, n) {
          function r(e) {
            function n() {
              var n = s.exec(e);
              a = n ? n[0] : void 0;
            }
            function r() {
              if ("(" !== a) {
                var e;
                return (e = Number(a)), n(), e;
              }
              n();
              var r = o();
              return ")" !== a ? NaN : (n(), r);
            }
            function i() {
              for (var e = r(); "*" === a || "/" === a; ) {
                var i = a;
                n();
                var o = r();
                "*" === i ? (e *= o) : (e /= o);
              }
              return e;
            }
            function o() {
              for (var e = i(); "+" === a || "-" === a; ) {
                var r = a;
                n();
                var o = i();
                "+" === r ? (e += o) : (e -= o);
              }
              return e;
            }
            var a,
              s = /([\+\-\w\.]+|[\(\)\*\/])/g;
            return n(), o();
          }
          function i(e, n) {
            if ("0" == (n = n.trim().toLowerCase()) && "px".search(e) >= 0)
              return { px: 0 };
            if (/^[^(]*$|^calc/.test(n)) {
              n = n.replace(/calc\(/g, "(");
              var i = {};
              n = n.replace(e, function (e) {
                return (i[e] = null), "U" + e;
              });
              for (
                var o = "U(" + e.source + ")",
                  a = n
                    .replace(/[-+]?(\d*\.)?\d+([Ee][-+]?\d+)?/g, "N")
                    .replace(RegExp("N" + o, "g"), "D")
                    .replace(/\s[+-]\s/g, "O")
                    .replace(/\s/g, ""),
                  s = [/N\*(D)/g, /(N|D)[*\/]N/g, /(N|D)O\1/g, /\((N|D)\)/g],
                  l = 0;
                l < s.length;

              )
                s[l].test(a) ? ((a = a.replace(s[l], "$1")), (l = 0)) : l++;
              if ("D" == a) {
                for (var u in i) {
                  var c = r(
                    n
                      .replace(RegExp("U" + u, "g"), "")
                      .replace(RegExp(o, "g"), "*0")
                  );
                  if (!isFinite(c)) return;
                  i[u] = c;
                }
                return i;
              }
            }
          }
          function o(e, n) {
            return a(e, n, !0);
          }
          function a(n, r, i) {
            var o,
              a = [];
            for (o in n) a.push(o);
            for (o in r) 0 > a.indexOf(o) && a.push(o);
            return [
              (n = a.map(function (e) {
                return n[e] || 0;
              })),
              (r = a.map(function (e) {
                return r[e] || 0;
              })),
              function (n) {
                var r = n
                  .map(function (r, o) {
                    return (
                      1 == n.length && i && (r = Math.max(r, 0)),
                      e.numberToString(r) + a[o]
                    );
                  })
                  .join(" + ");
                return n.length > 1 ? "calc(" + r + ")" : r;
              },
            ];
          }
          var s = "px|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc",
            l = i.bind(null, RegExp(s, "g")),
            u = i.bind(null, RegExp(s + "|%", "g")),
            c = i.bind(null, /deg|rad|grad|turn/g);
          (e.parseLength = l),
            (e.parseLengthOrPercent = u),
            (e.consumeLengthOrPercent = e.consumeParenthesised.bind(null, u)),
            (e.parseAngle = c),
            (e.mergeDimensions = a);
          var f = e.consumeParenthesised.bind(null, l),
            $ = e.consumeRepeated.bind(void 0, f, /^/),
            d = e.consumeRepeated.bind(void 0, $, /^,/);
          e.consumeSizePairList = d;
          var h = e.mergeNestedRepeated.bind(void 0, o, " "),
            p = e.mergeNestedRepeated.bind(void 0, h, ",");
          (e.mergeNonNegativeSizePair = h),
            e.addPropertiesHandler(
              function (e) {
                var n = d(e);
                if (n && "" == n[1]) return n[0];
              },
              p,
              ["background-size"]
            ),
            e.addPropertiesHandler(u, o, [
              "border-bottom-width",
              "border-image-width",
              "border-left-width",
              "border-right-width",
              "border-top-width",
              "flex-basis",
              "font-size",
              "height",
              "line-height",
              "max-height",
              "max-width",
              "outline-width",
              "width",
            ]),
            e.addPropertiesHandler(u, a, [
              "border-bottom-left-radius",
              "border-bottom-right-radius",
              "border-top-left-radius",
              "border-top-right-radius",
              "bottom",
              "left",
              "letter-spacing",
              "margin-bottom",
              "margin-left",
              "margin-right",
              "margin-top",
              "min-height",
              "min-width",
              "outline-offset",
              "padding-bottom",
              "padding-left",
              "padding-right",
              "padding-top",
              "perspective",
              "right",
              "shape-margin",
              "stroke-dashoffset",
              "text-indent",
              "top",
              "vertical-align",
              "word-spacing",
            ]);
        })(i),
        (function (e, n) {
          function r(n) {
            return e.consumeLengthOrPercent(n) || e.consumeToken(/^auto/, n);
          }
          function i(n) {
            var i = e.consumeList(
              [
                e.ignore(e.consumeToken.bind(null, /^rect/)),
                e.ignore(e.consumeToken.bind(null, /^\(/)),
                e.consumeRepeated.bind(null, r, /^,/),
                e.ignore(e.consumeToken.bind(null, /^\)/)),
              ],
              n
            );
            if (i && 4 == i[0].length) return i[0];
          }
          var o = e.mergeWrappedNestedRepeated.bind(
            null,
            function (e) {
              return "rect(" + e + ")";
            },
            function (n, r) {
              return "auto" == n || "auto" == r
                ? [
                    !0,
                    !1,
                    function (i) {
                      var o = i ? n : r;
                      if ("auto" == o) return "auto";
                      var a = e.mergeDimensions(o, o);
                      return a[2](a[0]);
                    },
                  ]
                : e.mergeDimensions(n, r);
            },
            ", "
          );
          (e.parseBox = i),
            (e.mergeBoxes = o),
            e.addPropertiesHandler(i, o, ["clip"]);
        })(i),
        (function (e, n) {
          function r(e) {
            return function (n) {
              var r = 0;
              return e.map(function (e) {
                return e === c ? n[r++] : e;
              });
            };
          }
          function i(e) {
            return e;
          }
          function o(n) {
            if ("none" == (n = n.toLowerCase().trim())) return [];
            for (
              var r, i = /\s*(\w+)\(([^)]*)\)/g, o = [], a = 0;
              (r = i.exec(n));

            ) {
              if (r.index != a) return;
              a = r.index + r[0].length;
              var s = r[1],
                l = d[s];
              if (!l) return;
              var u = r[2].split(","),
                c = l[0];
              if (c.length < u.length) return;
              for (var h = [], p = 0; p < c.length; p++) {
                var m,
                  g = u[p],
                  _ = c[p];
                if (
                  void 0 ===
                  (m = g
                    ? {
                        A: function (n) {
                          return "0" == n.trim() ? $ : e.parseAngle(n);
                        },
                        N: e.parseNumber,
                        T: e.parseLengthOrPercent,
                        L: e.parseLength,
                      }[_.toUpperCase()](g)
                    : { a: $, n: h[0], t: f }[_])
                )
                  return;
                h.push(m);
              }
              if ((o.push({ t: s, d: h }), i.lastIndex == n.length)) return o;
            }
          }
          function a(e) {
            return e.toFixed(6).replace(".000000", "");
          }
          function s(n, r) {
            if (n.decompositionPair !== r) {
              n.decompositionPair = r;
              var i = e.makeMatrixDecomposition(n);
            }
            if (r.decompositionPair !== n) {
              r.decompositionPair = n;
              var o = e.makeMatrixDecomposition(r);
            }
            return null == i[0] || null == o[0]
              ? [
                  [!1],
                  [!0],
                  function (e) {
                    return e ? r[0].d : n[0].d;
                  },
                ]
              : (i[0].push(0),
                o[0].push(1),
                [
                  i,
                  o,
                  function (n) {
                    var r = e.quat(i[0][3], o[0][3], n[5]);
                    return e
                      .composeMatrix(n[0], n[1], n[2], r, n[4])
                      .map(a)
                      .join(",");
                  },
                ]);
          }
          function l(e) {
            return e.replace(/[xy]/, "");
          }
          function u(e) {
            return e.replace(/(x|y|z|3d)?$/, "3d");
          }
          var c = null,
            f = { px: 0 },
            $ = { deg: 0 },
            d = {
              matrix: [
                "NNNNNN",
                [c, c, 0, 0, c, c, 0, 0, 0, 0, 1, 0, c, c, 0, 1],
                i,
              ],
              matrix3d: ["NNNNNNNNNNNNNNNN", i],
              rotate: ["A"],
              rotatex: ["A"],
              rotatey: ["A"],
              rotatez: ["A"],
              rotate3d: ["NNNA"],
              perspective: ["L"],
              scale: ["Nn", r([c, c, 1]), i],
              scalex: ["N", r([c, 1, 1]), r([c, 1])],
              scaley: ["N", r([1, c, 1]), r([1, c])],
              scalez: ["N", r([1, 1, c])],
              scale3d: ["NNN", i],
              skew: ["Aa", null, i],
              skewx: ["A", null, r([c, $])],
              skewy: ["A", null, r([$, c])],
              translate: ["Tt", r([c, c, f]), i],
              translatex: ["T", r([c, f, f]), r([c, f])],
              translatey: ["T", r([f, c, f]), r([f, c])],
              translatez: ["L", r([f, f, c])],
              translate3d: ["TTL", i],
            };
          e.addPropertiesHandler(
            o,
            function (n, r) {
              var i = e.makeMatrixDecomposition && !0,
                o = !1;
              if (!n.length || !r.length) {
                n.length || ((o = !0), (n = r), (r = []));
                for (var a = 0; a < n.length; a++) {
                  var c = n[a].t,
                    f = n[a].d,
                    $ = "scale" == c.substr(0, 5) ? 1 : 0;
                  r.push({
                    t: c,
                    d: f.map(function (e) {
                      if ("number" == typeof e) return $;
                      var n = {};
                      for (var r in e) n[r] = $;
                      return n;
                    }),
                  });
                }
              }
              var h,
                p,
                m = [],
                g = [],
                _ = [];
              if (n.length != r.length) {
                if (!i) return;
                (m = [(E = s(n, r))[0]]),
                  (g = [E[1]]),
                  (_ = [["matrix", [E[2]]]]);
              } else
                for (a = 0; a < n.length; a++) {
                  var v = n[a].t,
                    b = r[a].t,
                    y = n[a].d,
                    T = r[a].d,
                    w = d[v],
                    x = d[b];
                  if (
                    ((p = b),
                    ("perspective" == (h = v) && "perspective" == p) ||
                      (("matrix" == h || "matrix3d" == h) &&
                        ("matrix" == p || "matrix3d" == p)))
                  ) {
                    if (!i) return;
                    var E = s([n[a]], [r[a]]);
                    m.push(E[0]), g.push(E[1]), _.push(["matrix", [E[2]]]);
                  } else {
                    if (v == b) c = v;
                    else if (w[2] && x[2] && l(v) == l(b))
                      (c = l(v)), (y = w[2](y)), (T = x[2](T));
                    else {
                      if (!w[1] || !x[1] || u(v) != u(b)) {
                        if (!i) return;
                        (m = [(E = s(n, r))[0]]),
                          (g = [E[1]]),
                          (_ = [["matrix", [E[2]]]]);
                        break;
                      }
                      (c = u(v)), (y = w[1](y)), (T = x[1](T));
                    }
                    for (var k = [], P = [], S = [], R = 0; R < y.length; R++)
                      (E = (
                        "number" == typeof y[R]
                          ? e.mergeNumbers
                          : e.mergeDimensions
                      )(y[R], T[R])),
                        (k[R] = E[0]),
                        (P[R] = E[1]),
                        S.push(E[2]);
                    m.push(k), g.push(P), _.push([c, S]);
                  }
                }
              if (o) {
                var A = m;
                (m = g), (g = A);
              }
              return [
                m,
                g,
                function (e) {
                  return e
                    .map(function (e, n) {
                      var r = e
                        .map(function (e, r) {
                          return _[n][1][r](e);
                        })
                        .join(",");
                      return (
                        "matrix" == _[n][0] &&
                          16 == r.split(",").length &&
                          (_[n][0] = "matrix3d"),
                        _[n][0] + "(" + r + ")"
                      );
                    })
                    .join(" ");
                },
              ];
            },
            ["transform"]
          ),
            (e.transformToSvgMatrix = function (n) {
              var r = e.transformListToMatrix(o(n));
              return (
                "matrix(" +
                a(r[0]) +
                " " +
                a(r[1]) +
                " " +
                a(r[4]) +
                " " +
                a(r[5]) +
                " " +
                a(r[12]) +
                " " +
                a(r[13]) +
                ")"
              );
            });
        })(i),
        (function (e) {
          function n(n) {
            return (
              (n = 100 * Math.round(n / 100)),
              400 === (n = e.clamp(100, 900, n))
                ? "normal"
                : 700 === n
                ? "bold"
                : String(n)
            );
          }
          e.addPropertiesHandler(
            function (e) {
              var n = Number(e);
              if (!(isNaN(n) || n < 100 || n > 900 || n % 100 != 0)) return n;
            },
            function (e, r) {
              return [e, r, n];
            },
            ["font-weight"]
          );
        })(i),
        (function (e) {
          function n(e) {
            var n = {};
            for (var r in e) n[r] = -e[r];
            return n;
          }
          function r(n) {
            return (
              e.consumeToken(/^(left|center|right|top|bottom)\b/i, n) ||
              e.consumeLengthOrPercent(n)
            );
          }
          function i(n, i) {
            var o = e.consumeRepeated(r, /^/, i);
            if (o && "" == o[1]) {
              var s = o[0];
              if (
                ((s[0] = s[0] || "center"),
                (s[1] = s[1] || "center"),
                3 == n && (s[2] = s[2] || { px: 0 }),
                s.length == n)
              ) {
                if (/top|bottom/.test(s[0]) || /left|right/.test(s[1])) {
                  var l = s[0];
                  (s[0] = s[1]), (s[1] = l);
                }
                if (
                  /left|right|center|Object/.test(s[0]) &&
                  /top|bottom|center|Object/.test(s[1])
                )
                  return s.map(function (e) {
                    return "object" == typeof e ? e : a[e];
                  });
              }
            }
          }
          function o(i) {
            var o = e.consumeRepeated(r, /^/, i);
            if (o) {
              for (
                var s = o[0],
                  l = [{ "%": 50 }, { "%": 50 }],
                  u = 0,
                  c = !1,
                  f = 0;
                f < s.length;
                f++
              ) {
                var $ = s[f];
                "string" == typeof $
                  ? ((c = /bottom|right/.test($)),
                    (l[
                      (u = { left: 0, right: 0, center: u, top: 1, bottom: 1 }[
                        $
                      ])
                    ] = a[$]),
                    "center" == $ && u++)
                  : (c && (($ = n($))["%"] = ($["%"] || 0) + 100),
                    (l[u] = $),
                    u++,
                    (c = !1));
              }
              return [l, o[1]];
            }
          }
          var a = {
              left: { "%": 0 },
              center: { "%": 50 },
              right: { "%": 100 },
              top: { "%": 0 },
              bottom: { "%": 100 },
            },
            s = e.mergeNestedRepeated.bind(null, e.mergeDimensions, " ");
          e.addPropertiesHandler(i.bind(null, 3), s, ["transform-origin"]),
            e.addPropertiesHandler(i.bind(null, 2), s, ["perspective-origin"]),
            (e.consumePosition = o),
            (e.mergeOffsetList = s);
          var l = e.mergeNestedRepeated.bind(null, s, ", ");
          e.addPropertiesHandler(
            function (n) {
              var r = e.consumeRepeated(o, /^,/, n);
              if (r && "" == r[1]) return r[0];
            },
            l,
            ["background-position", "object-position"]
          );
        })(i),
        (function (e) {
          var n = e.consumeParenthesised.bind(null, e.parseLengthOrPercent),
            r = e.consumeRepeated.bind(void 0, n, /^/),
            i = e.mergeNestedRepeated.bind(void 0, e.mergeDimensions, " "),
            o = e.mergeNestedRepeated.bind(void 0, i, ",");
          e.addPropertiesHandler(
            function (i) {
              var o = e.consumeToken(/^circle/, i);
              if (o && o[0])
                return ["circle"].concat(
                  e.consumeList(
                    [
                      e.ignore(e.consumeToken.bind(void 0, /^\(/)),
                      n,
                      e.ignore(e.consumeToken.bind(void 0, /^at/)),
                      e.consumePosition,
                      e.ignore(e.consumeToken.bind(void 0, /^\)/)),
                    ],
                    o[1]
                  )
                );
              var a = e.consumeToken(/^ellipse/, i);
              if (a && a[0])
                return ["ellipse"].concat(
                  e.consumeList(
                    [
                      e.ignore(e.consumeToken.bind(void 0, /^\(/)),
                      r,
                      e.ignore(e.consumeToken.bind(void 0, /^at/)),
                      e.consumePosition,
                      e.ignore(e.consumeToken.bind(void 0, /^\)/)),
                    ],
                    a[1]
                  )
                );
              var s = e.consumeToken(/^polygon/, i);
              return s && s[0]
                ? ["polygon"].concat(
                    e.consumeList(
                      [
                        e.ignore(e.consumeToken.bind(void 0, /^\(/)),
                        e.optional(
                          e.consumeToken.bind(
                            void 0,
                            /^nonzero\s*,|^evenodd\s*,/
                          ),
                          "nonzero,"
                        ),
                        e.consumeSizePairList,
                        e.ignore(e.consumeToken.bind(void 0, /^\)/)),
                      ],
                      s[1]
                    )
                  )
                : void 0;
            },
            function (n, r) {
              if (n[0] === r[0])
                return "circle" == n[0]
                  ? e.mergeList(n.slice(1), r.slice(1), [
                      "circle(",
                      e.mergeDimensions,
                      " at ",
                      e.mergeOffsetList,
                      ")",
                    ])
                  : "ellipse" == n[0]
                  ? e.mergeList(n.slice(1), r.slice(1), [
                      "ellipse(",
                      e.mergeNonNegativeSizePair,
                      " at ",
                      e.mergeOffsetList,
                      ")",
                    ])
                  : "polygon" == n[0] && n[1] == r[1]
                  ? e.mergeList(n.slice(2), r.slice(2), [
                      "polygon(",
                      n[1],
                      o,
                      ")",
                    ])
                  : void 0;
            },
            ["shape-outside"]
          );
        })(i),
        (function (e, n) {
          function r(e, n) {
            n.concat([e]).forEach(function (n) {
              n in document.documentElement.style && (i[e] = n), (o[n] = e);
            });
          }
          var i = {},
            o = {};
          r("transform", ["webkitTransform", "msTransform"]),
            r("transformOrigin", ["webkitTransformOrigin"]),
            r("perspective", ["webkitPerspective"]),
            r("perspectiveOrigin", ["webkitPerspectiveOrigin"]),
            (e.propertyName = function (e) {
              return i[e] || e;
            }),
            (e.unprefixedPropertyName = function (e) {
              return o[e] || e;
            });
        })(i);
    })(),
    (function () {
      if (void 0 === document.createElement("div").animate([]).oncancel) {
        if (window.performance && performance.now)
          var e = function () {
            return performance.now();
          };
        else
          e = function () {
            return Date.now();
          };
        var n = function (e, n, r) {
            (this.target = e),
              (this.currentTime = n),
              (this.timelineTime = r),
              (this.type = "cancel"),
              (this.bubbles = !1),
              (this.cancelable = !1),
              (this.currentTarget = e),
              (this.defaultPrevented = !1),
              (this.eventPhase = Event.AT_TARGET),
              (this.timeStamp = Date.now());
          },
          r = window.Element.prototype.animate;
        window.Element.prototype.animate = function (i, o) {
          var a = r.call(this, i, o);
          (a._cancelHandlers = []), (a.oncancel = null);
          var s = a.cancel;
          a.cancel = function () {
            s.call(this);
            var r = new n(this, null, e()),
              i = this._cancelHandlers.concat(
                this.oncancel ? [this.oncancel] : []
              );
            setTimeout(function () {
              i.forEach(function (e) {
                e.call(r.target, r);
              });
            }, 0);
          };
          var l = a.addEventListener;
          a.addEventListener = function (e, n) {
            "function" == typeof n && "cancel" == e
              ? this._cancelHandlers.push(n)
              : l.call(this, e, n);
          };
          var u = a.removeEventListener;
          return (
            (a.removeEventListener = function (e, n) {
              if ("cancel" == e) {
                var r = this._cancelHandlers.indexOf(n);
                r >= 0 && this._cancelHandlers.splice(r, 1);
              } else u.call(this, e, n);
            }),
            a
          );
        };
      }
    })(),
    (function (e) {
      var n = document.documentElement,
        r = null,
        i = !1;
      try {
        var o =
          "0" == getComputedStyle(n).getPropertyValue("opacity") ? "1" : "0";
        ((r = n.animate({ opacity: [o, o] }, { duration: 1 })).currentTime = 0),
          (i = getComputedStyle(n).getPropertyValue("opacity") == o);
      } catch (a) {
      } finally {
        r && r.cancel();
      }
      if (!i) {
        var s = window.Element.prototype.animate;
        window.Element.prototype.animate = function (n, r) {
          return (
            window.Symbol &&
              Symbol.iterator &&
              Array.prototype.from &&
              n[Symbol.iterator] &&
              (n = Array.from(n)),
            Array.isArray(n) || null === n || (n = e.convertToArrayForm(n)),
            s.call(this, n, r)
          );
        };
      }
    })(r),
    (function (e, n) {
      if ("function" != typeof e.createEvent) return !1;
      var r,
        i,
        o,
        a,
        s,
        l,
        u,
        c,
        f,
        $ = function (e) {
          var n = e.toLowerCase();
          return navigator.msPointerEnabled
            ? "MS" + e
            : !!window.PointerEvent && n;
        },
        d = function (e) {
          return "on" + e in window && e;
        },
        h = {
          useJquery: !n.IGNORE_JQUERY && "undefined" != typeof jQuery,
          swipeThreshold: n.SWIPE_THRESHOLD || 100,
          tapThreshold: n.TAP_THRESHOLD || 150,
          dbltapThreshold: n.DBL_TAP_THRESHOLD || 200,
          longtapThreshold: n.LONG_TAP_THRESHOLD || 1e3,
          tapPrecision: n.TAP_PRECISION / 2 || 30,
          justTouchEvents: n.JUST_ON_TOUCH_DEVICES,
        },
        p = !1,
        m = d("touchstart") || $("PointerDown"),
        g = d("touchend") || $("PointerUp"),
        _ = d("touchmove") || $("PointerMove"),
        v = function (e) {
          return !e.pointerId || void 0 === r || e.pointerId === r;
        },
        b = function (e, n, r) {
          for (var i = n.split(" "), o = i.length; o--; )
            e.addEventListener(i[o], r, !1);
        },
        y = function (e) {
          var n = Boolean(e.targetTouches && e.targetTouches.length);
          switch (!0) {
            case Boolean(e.target.touches):
              return e.target.touches[0];
            case n && void 0 !== e.targetTouches[0].pageX:
              return e.targetTouches[0];
            case n && Boolean(e.targetTouches[0].touches):
              return e.targetTouches[0].touches[0];
            default:
              return e;
          }
        },
        T = function (e) {
          return (e.targetTouches || e.target.touches || []).length > 1;
        },
        w = function () {
          return new Date().getTime();
        },
        x = function (n, r, a, s) {
          var l = e.createEvent("Event");
          if (
            ((l.originalEvent = a),
            ((s = s || {}).x = i),
            (s.y = o),
            h.useJquery &&
              ((l = jQuery.Event(r, { originalEvent: a })),
              jQuery(n).trigger(l, s)),
            l.initEvent)
          ) {
            for (var u in s) l[u] = s[u];
            l.initEvent(r, !0, !0), n.dispatchEvent(l);
          }
          for (; n; ) n["on" + r] && n["on" + r](l), (n = n.parentNode);
        },
        E = 0;
      b(e, m + (h.justTouchEvents ? "" : " mousedown"), function (e) {
        if (
          v(e) &&
          !T(e) &&
          ((r = e.pointerId),
          "mousedown" !== e.type && (p = !0),
          "mousedown" !== e.type || !p)
        ) {
          var n = y(e);
          (a = i = n.pageX),
            (s = o = n.pageY),
            (f = setTimeout(function () {
              x(e.target, "longtap", e), (u = e.target);
            }, h.longtapThreshold)),
            (l = w()),
            E++;
        }
      }),
        b(e, g + (h.justTouchEvents ? "" : " mouseup"), function (e) {
          if (v(e) && !T(e)) {
            if (((r = void 0), "mouseup" === e.type && p)) p = !1;
            else {
              var n = [],
                $ = w(),
                d = s - o,
                m = a - i;
              if (
                (clearTimeout(c),
                clearTimeout(f),
                m <= -h.swipeThreshold && n.push("swiperight"),
                m >= h.swipeThreshold && n.push("swipeleft"),
                d <= -h.swipeThreshold && n.push("swipedown"),
                d >= h.swipeThreshold && n.push("swipeup"),
                n.length)
              ) {
                for (var g = 0; g < n.length; g++) {
                  var _ = n[g];
                  x(e.target, _, e, {
                    distance: { x: Math.abs(m), y: Math.abs(d) },
                  });
                }
                E = 0;
              } else
                a >= i - h.tapPrecision &&
                  a <= i + h.tapPrecision &&
                  s >= o - h.tapPrecision &&
                  s <= o + h.tapPrecision &&
                  l + h.tapThreshold - $ >= 0 &&
                  (x(e.target, E >= 2 && u === e.target ? "dbltap" : "tap", e),
                  (u = e.target)),
                  (c = setTimeout(function () {
                    E = 0;
                  }, h.dbltapThreshold));
            }
          }
        }),
        b(e, _ + (h.justTouchEvents ? "" : " mousemove"), function (e) {
          if (v(e) && ("mousemove" !== e.type || !p)) {
            var n = y(e);
            (i = n.pageX), (o = n.pageY);
          }
        }),
        (n.tocca = function (e) {
          for (var n in e) h[n] = e[n];
          return h;
        });
    })(document, window);
  var e,
    n,
    r,
    i,
    o,
    a,
    s = new Set(),
    l = document.createElement("link"),
    u =
      l.relList &&
      l.relList.supports &&
      l.relList.supports("prefetch") &&
      window.IntersectionObserver &&
      "isIntersecting" in IntersectionObserverEntry.prototype,
    c = "instantAllowQueryString" in document.body.dataset,
    f = "instantAllowExternalLinks" in document.body.dataset,
    $ = "instantWhitelist" in document.body.dataset,
    d = "instantMousedownShortcut" in document.body.dataset,
    h = 65,
    p = !1,
    m = !1,
    g = !1;
  if ("instantIntensity" in document.body.dataset) {
    let _ = document.body.dataset.instantIntensity;
    if ("mousedown" == _.substr(0, 9))
      (p = !0), "mousedown-only" == _ && (m = !0);
    else if ("viewport" == _.substr(0, 8))
      (navigator.connection &&
        (navigator.connection.saveData ||
          (navigator.connection.effectiveType &&
            navigator.connection.effectiveType.includes("2g")))) ||
        ("viewport" == _
          ? document.documentElement.clientWidth *
              document.documentElement.clientHeight <
              45e4 && (g = !0)
          : "viewport-all" == _ && (g = !0));
    else {
      let v = parseInt(_);
      isNaN(v) || (h = v);
    }
  }
  if (u) {
    let b = { capture: !0, passive: !0 };
    if (
      (m ||
        document.addEventListener(
          "touchstart",
          function (e) {
            a = performance.now();
            let n = e.target.closest("a");
            w(n) && x(n.href);
          },
          b
        ),
      p
        ? d ||
          document.addEventListener(
            "mousedown",
            function (e) {
              let n = e.target.closest("a");
              w(n) && x(n.href);
            },
            b
          )
        : document.addEventListener(
            "mouseover",
            function (e) {
              if (performance.now() - a < 1111) return;
              let n = e.target.closest("a");
              w(n) &&
                (n.addEventListener("mouseout", T, { passive: !0 }),
                (o = setTimeout(() => {
                  x(n.href), (o = void 0);
                }, h)));
            },
            b
          ),
      d &&
        document.addEventListener(
          "mousedown",
          function (e) {
            if (performance.now() - a < 1111) return;
            let n = e.target.closest("a");
            if (e.which > 1 || e.metaKey || e.ctrlKey || !n) return;
            n.addEventListener(
              "click",
              function (e) {
                1337 != e.detail && e.preventDefault();
              },
              { capture: !0, passive: !1, once: !0 }
            );
            let r = new MouseEvent("click", {
              view: window,
              bubbles: !0,
              cancelable: !1,
              detail: 1337,
            });
            n.dispatchEvent(r);
          },
          b
        ),
      g)
    ) {
      let y;
      (y = window.requestIdleCallback
        ? (e) => {
            requestIdleCallback(e, { timeout: 1500 });
          }
        : (e) => {
            e();
          })(() => {
        let e = new IntersectionObserver((n) => {
          n.forEach((n) => {
            if (n.isIntersecting) {
              let r = n.target;
              e.unobserve(r), x(r.href);
            }
          });
        });
        document.querySelectorAll("a").forEach((n) => {
          w(n) && e.observe(n);
        });
      });
    }
  }
  function T(e) {
    (e.relatedTarget &&
      e.target.closest("a") == e.relatedTarget.closest("a")) ||
      (o && (clearTimeout(o), (o = void 0)));
  }
  function w(e) {
    if (
      e &&
      e.href &&
      (!$ || "instant" in e.dataset) &&
      (f || e.origin == location.origin || "instant" in e.dataset) &&
      ["http:", "https:"].includes(e.protocol) &&
      ("http:" != e.protocol || "https:" != location.protocol) &&
      (c || !e.search || "instant" in e.dataset) &&
      !(
        (e.hash &&
          e.pathname + e.search == location.pathname + location.search) ||
        "noInstant" in e.dataset
      )
    )
      return !0;
  }
  function x(e) {
    if (s.has(e)) return;
    let n = document.createElement("link");
    (n.rel = "prefetch"), (n.href = e), document.head.appendChild(n), s.add(e);
  }
  var E = (e) =>
    void 0 === e || "auto" === e || "instant" === e || "smooth" === e;
  function k(e, n) {
    (this.scrollLeft = e), (this.scrollTop = n);
  }
  var P = (e, n, r = "cannot convert to dictionary.") =>
      `Failed to execute '${e}' on '${n}': ${r}`,
    S = (e, n, r) =>
      P(
        e,
        n,
        `The provided value '${r}' is not a valid enum value of type ScrollBehavior.`
      ),
    R = (e, n, r) => {
      var i;
      let o = `__SEAMLESS.BACKUP$${n}`;
      return (
        e[o] ||
          !e[n] ||
          (null == (i = e[n]) ? void 0 : i.__isPolyfill) ||
          (e[o] = e[n]),
        e[o] || r
      );
    },
    A = (e) => {
      let n = typeof e;
      return null !== e && ("object" === n || "function" === n);
    },
    L = () => "scrollBehavior" in window.document.documentElement.style,
    N = (e) => {
      Object.defineProperty(e, "__isPolyfill", { value: !0 });
    },
    D = (e, n) => {
      N(n),
        [
          HTMLElement.prototype,
          SVGElement.prototype,
          Element.prototype,
        ].forEach((r) => {
          R(r, e), (r[e] = n);
        });
    },
    O = (e) =>
      e.ownerDocument.scrollingElement || e.ownerDocument.documentElement,
    C = (e) => 0.5 * (1 - Math.cos(Math.PI * e)),
    I = () => {
      var e, n, r;
      return null !=
        (r =
          null == (n = null == (e = window.performance) ? void 0 : e.now)
            ? void 0
            : n.call(e))
        ? r
        : window.Date.now();
    },
    H = (e) => {
      let n = (I() - e.timeStamp) / (e.duration || 500);
      if (n > 1) return e.method(e.targetX, e.targetY), void e.callback();
      let r = (e.timingFunc || C)(n),
        i = e.startX + (e.targetX - e.startX) * r,
        o = e.startY + (e.targetY - e.startY) * r;
      e.method(i, o),
        (e.rafId = window.requestAnimationFrame(() => {
          H(e);
        }));
    },
    W = (e) => (isFinite(e) ? Number(e) : 0),
    M = (e) => (n, r, i) => {
      var o;
      let [a, s] =
          (o = n).window === o
            ? [O(n.document.documentElement), "Window"]
            : [n, "Element"],
        l = null != r ? r : {};
      if (!A(l)) throw TypeError(P(e, s));
      if (!E(l.behavior)) throw TypeError(S(e, s, l.behavior));
      "scrollBy" === e &&
        ((l.left = W(l.left) + a.scrollLeft), (l.top = W(l.top) + a.scrollTop)),
        ((e, n, r) => {
          var i, o;
          if (
            !((e) => {
              var n;
              return null != (n = e.isConnected)
                ? n
                : !(
                    e.ownerDocument &&
                    1 & e.ownerDocument.compareDocumentPosition(e)
                  );
            })(e)
          )
            return;
          let a = e.scrollLeft,
            s = e.scrollTop,
            l = W(null != (i = n.left) ? i : a),
            u = W(null != (o = n.top) ? o : s);
          if (l === a && u === s) return;
          let c = R(HTMLElement.prototype, "scroll", k),
            f = R(Object.getPrototypeOf(e), "scroll", c).bind(e);
          if ("smooth" !== n.behavior) return void f(l, u);
          let $ = () => {
              window.removeEventListener("wheel", h),
                window.removeEventListener("touchmove", h);
            },
            d = {
              ...r,
              timeStamp: I(),
              startX: a,
              startY: s,
              targetX: l,
              targetY: u,
              rafId: 0,
              method: f,
              callback: $,
            },
            h = () => {
              window.cancelAnimationFrame(d.rafId), $();
            };
          window.addEventListener("wheel", h, { passive: !0, once: !0 }),
            window.addEventListener("touchmove", h, { passive: !0, once: !0 }),
            H(d);
        })(a, l, i);
    },
    F = M("scroll"),
    B = M("scrollTo"),
    q = M("scrollBy"),
    z = F,
    V = (e) => {
      switch (e) {
        case "horizontal-tb":
        case "lr":
        case "lr-tb":
        case "rl":
        case "rl-tb":
          break;
        case "vertical-rl":
        case "tb":
        case "tb-rl":
          return 1;
        case "vertical-lr":
        case "tb-lr":
          return 2;
        case "sideways-rl":
          return 3;
        case "sideways-lr":
          return 4;
      }
      return 0;
    },
    U = (e, n, r, i) => {
      let o = 0;
      switch ((n || (o ^= 2), e)) {
        case 0:
          (o = (o >> 1) | ((1 & o) << 1)), ([r, i] = [i, r]);
          break;
        case 1:
        case 3:
          o ^= 1;
          break;
        case 4:
          o ^= 2;
      }
      return [o, r, i];
    },
    j = (e) =>
      1 == (1 & U(V(e.writingMode), "rtl" !== e.direction, void 0, void 0)[0]),
    K = (e, n, r, i, o, a, s) =>
      0 !== e
        ? e
        : (o < n && a > r) || (o > n && a < r)
        ? null
        : (o <= n && s <= i) || (a >= r && s >= i)
        ? 2
        : (a > r && s < i) || (o < n && s > i)
        ? 3
        : null,
    X = (e) => "visible" !== e && "clip" !== e,
    Y = (e, n) =>
      (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) &&
      (X(n.overflowY) || X(n.overflowX) || e === O(e)),
    G = (e) => {
      let n = e.parentNode,
        r = e.parentElement;
      if (null === r && null !== n) {
        if (11 === n.nodeType) return n.host;
        if (9 === n.nodeType)
          return ((e) => {
            var n;
            try {
              return (
                (null == (n = e.ownerDocument.defaultView)
                  ? void 0
                  : n.frameElement) || null
              );
            } catch {
              return null;
            }
          })(e);
      }
      return r;
    },
    J = (e, n, r) => (e < n ? n : e > r ? r : e),
    Q = (e, n, r) => {
      switch (e) {
        case 1:
          return (n + r) / 2;
        case 3:
          return r;
        case 2:
        case 0:
          return n;
      }
    },
    Z = (e, n) => {
      var r, i, o;
      let a =
          null == (r = e.ownerDocument.defaultView) ? void 0 : r.visualViewport,
        [s, l, u, c] =
          e === O(e)
            ? [
                0,
                0,
                null != (i = null == a ? void 0 : a.width) ? i : e.clientWidth,
                null != (o = null == a ? void 0 : a.height)
                  ? o
                  : e.clientHeight,
              ]
            : [n.left, n.top, e.clientWidth, e.clientHeight],
        f = s + e.clientLeft,
        $ = l + e.clientTop;
      return [$, f + u, $ + c, f];
    },
    ee = (e, n, r) => {
      let i = n || {};
      if (!E(i.behavior))
        throw TypeError(S("scrollIntoView", "Element", i.behavior));
      ((e, n) => {
        let r = [],
          i = e.ownerDocument,
          o = i.defaultView;
        if (!o) return r;
        let a = window.getComputedStyle(e),
          s = "rtl" !== a.direction,
          l = V(
            a.writingMode ||
              a.getPropertyValue("-webkit-writing-mode") ||
              a.getPropertyValue("-ms-writing-mode")
          ),
          [u, c] = ((e, n, r) => {
            let [i, o, a] = U(n, r, e.block || "start", e.inline || "nearest");
            return [o, a].map((e, n) => {
              switch (e) {
                case "center":
                  return 1;
                case "nearest":
                  return 0;
                default:
                  return ("start" === e) == !((i >> n) & 1) ? 2 : 3;
              }
            });
          })(n, l, s),
          [f, $, d, h] = ((e, n, r) => {
            var i;
            let { top: o, right: a, bottom: s, left: l } = n,
              u =
                ((i = e.ownerDocument),
                ["scroll-margin", "scroll-snap-margin"].filter(
                  (e) => e in i.documentElement.style
                )[0]);
            if (!u) return [o, a, s, l];
            let c = (e) => {
              let n = r.getPropertyValue(`${u}-${e}`);
              return parseInt(n, 10) || 0;
            };
            return [
              o - c("top"),
              a + c("right"),
              s + c("bottom"),
              l - c("left"),
            ];
          })(e, e.getBoundingClientRect(), a);
        for (let p = G(e); null !== p; p = G(p)) {
          if (i !== p.ownerDocument) {
            if (!(o = (i = p.ownerDocument).defaultView)) break;
            let { left: m, top: g } = p.getBoundingClientRect();
            (f += g), ($ += m), (d += g), (h += m);
          }
          let _ = o.getComputedStyle(p);
          if ("fixed" === _.position) break;
          if (!Y(p, _)) continue;
          let v = p.getBoundingClientRect(),
            [b, y, T, w] = Z(p, v),
            x = K(u, w, y, p.clientWidth, h, $, $ - h),
            E = K(c, b, T, p.clientHeight, f, d, d - f),
            k = null === x ? 0 : Q(x, h, $) - Q(x, w, y),
            P = null === E ? 0 : Q(E, f, d) - Q(E, b, T),
            S = j(_)
              ? J(
                  k,
                  -p.scrollWidth + p.clientWidth - p.scrollLeft,
                  -p.scrollLeft
                )
              : J(
                  k,
                  -p.scrollLeft,
                  p.scrollWidth - p.clientWidth - p.scrollLeft
                ),
            R = J(
              P,
              -p.scrollTop,
              p.scrollHeight - p.clientHeight - p.scrollTop
            );
          r.push([
            p,
            {
              left: p.scrollLeft + S,
              top: p.scrollTop + R,
              behavior: n.behavior,
            },
          ]),
            (f = Math.max(f - R, b)),
            ($ = Math.min($ - S, y)),
            (d = Math.min(d - R, T)),
            (h = Math.max(h - S, w));
        }
        return r;
      })(e, i).forEach(([e, n]) => {
        z(e, n, r);
      });
    },
    et = (e, n) => (r) => {
      if (L()) return;
      let i = { scroll: F, scrollTo: B, scrollBy: q }[e];
      n(e, function () {
        let e = arguments;
        if (1 === arguments.length) return void i(this, e[0], r);
        let n = e[0],
          o = e[1];
        i(this, { left: n, top: o });
      });
    },
    en = (et("scroll", D), et("scrollTo", D)),
    er = et("scrollBy", D),
    ei = (e, n) => {
      N(n), R(window, e), (window[e] = n);
    };
  function eo(e) {
    ee(this, { block: null == e || e ? "start" : "end", inline: "nearest" });
  }
  et("scroll", ei),
    et("scrollTo", ei),
    et("scrollBy", ei),
    ((e) => {
      if (L()) return;
      let n = R(window.HTMLElement.prototype, "scrollIntoView", eo);
      D("scrollIntoView", function () {
        let e = arguments,
          r = e[0];
        1 === e.length && A(r) ? ee(this, r, void 0) : n.apply(this, e);
      });
    })(),
    en(),
    er();
})();
